(function () {
  'use strict';

  var data = window.switchBuilderData;
  if (!data) return;

  // i18n strings injected by the section (product-main-switch-builder.liquid).
  // Values are already Liquid-escaped (passed via `| t | json`), so insert them
  // straight into innerHTML — do NOT pass them through escapeHtml again, or
  // entities would double-escape. Placeholder strings carry __TOKEN__ markers
  // that fillTokens() swaps for runtime values; escape any data/customer value
  // before passing it as a token. Each lookup keeps an English fallback so a
  // missing key degrades to English rather than breaking the builder.
  var I18N = data.i18n || {};
  function fillTokens(str, tokens) {
    if (str == null) return '';
    Object.keys(tokens).forEach(function (k) {
      str = str.split(k).join(tokens[k] == null ? '' : tokens[k]);
    });
    return str;
  }

  // ----------------------------------------------------------------
  // State
  // ----------------------------------------------------------------

  var state = {
    step: 1,
    totalSteps: 4,
    style: null,      // matches variant Option 1 (lowercased, hyphenated)
    finish: null,     // matches variant Option 2 (lowercased, hyphenated)
    size: null,       // matches variant Option 3 (size_key from bespoke_plates metaobject)
    sizeLabel: null,  // customer-facing size label from the selected plate option
    orientation: null, // matches variant Option 4 when present (vertical, horizontal)
    gangCount: null,  // integer, drives module slot count; set alongside size
    slots: {},        // { 1: moduleObj | { split: true, a: moduleObj|null, b: moduleObj|null } | null, … }

    // Engraving — flat-fee add-on. `values` is keyed by the cart property
    // name the plate line will carry (e.g. 'Position 1 (Above)', 'Position 2a (Below)').
    // `enabled` is derived from values being non-empty and is what
    // calculateTotalCents + buildCartItems check to decide whether to
    // charge the fee and send the props. `validityErrors` holds per-pair
    // > 2-line complaints so the Next button can be disabled.
    engraving: {
      enabled: false,
      values: {},
      validityErrors: 0
    },
    quantity: 1,
    termsAccepted: false
  };

  // ----------------------------------------------------------------
  // DOM cache
  // ----------------------------------------------------------------

  var builder           = document.getElementById('switch-builder');
  var previewPanel      = builder && builder.querySelector('.builder-preview-panel');
  var stepPanels        = builder.querySelectorAll('.builder-step-panel');
  var navBar            = document.getElementById('builder-nav-bar');
  var navFooter         = document.getElementById('builder-nav-footer');
  var backBtn           = document.getElementById('builder-back');
  var nextBtn           = document.getElementById('builder-next');
  var startBtn          = document.getElementById('builder-start');
  var headerPrice       = document.getElementById('builder-header-price');
  var priceContainer    = document.getElementById('builder-total-price');
  var priceValue        = document.getElementById('builder-price-value');
  var stockStatus       = document.getElementById('builder-stock-status');
  var stockNotice       = document.getElementById('builder-stock-notice');
  var orientationGroup  = document.getElementById('builder-orientation-group');
  var finishGroupEl     = document.getElementById('builder-finish-group');
  var sizeGroupEl       = document.getElementById('builder-size-group');
  var plateWrapper      = document.getElementById('preview-plate-wrapper');
  var plateImage        = document.getElementById('preview-plate-image');
  var moduleOverlays    = document.getElementById('preview-module-overlays');
  var engravingOverlay  = document.getElementById('preview-engraving-overlay');
  var emptyMsg          = document.getElementById('preview-empty-message');
  var slotsContainer    = document.getElementById('slots-container');
  var engravingInputs   = document.getElementById('builder-engraving-inputs');
  var engravingFeeBadge = document.getElementById('builder-engraving-fee-badge');
  var engravingError    = document.getElementById('builder-engraving-error');
  var reviewContent     = document.getElementById('review-content');
  var termsCheckbox     = document.getElementById('builder-terms-checkbox');
  var quantityWrap      = document.getElementById('builder-quantity');
  var quantitySelect    = document.getElementById('builder-quantity-select');
  var termsRequired     = builder && builder.dataset.termsRequired === 'true';
  var showIntro         = !!(startBtn && builder && builder.dataset.showIntro === 'true');

  if (showIntro) state.step = 0;

  // Step 2 — inline position config
  var expandedSlot      = null;
  var slotDrafts        = {}; // per-position in-progress picks before commit

  // Set true after a successful add-to-cart so the Review step's primary button
  // becomes a "Build another" reset instead of silently reverting to "Add to
  // basket" (Claudia/Asana feedback: after adding, the customer was stranded on
  // Review with the basket drawer open and no clear next step). Cleared on any
  // navigation (goToStep) so editing the config restores "Add to basket".
  var justAdded = false;
  // Re-entrancy guard for handleAddToCart — blocks a queued/double click while a
  // /cart/add.js request is already in flight.
  var isAdding = false;

  var PRESELECT_MODULE_FINISHES = ['bronze', 'antique-brass', 'polished-nickel', 'satin-nickel'];

  var DEFAULT_INSERT_COLOURS = [
    { value: 'black', label: 'Black', swatchColor: '#1a1a1a' },
    { value: 'white', label: 'White', swatchColor: '#f5f5f5' }
  ];

  var ST = I18N.switchTypes || {};
  // Region: 'eu' or 'us', from the section's builder_region setting. One JS serves both
  // bespoke templates on the consolidated .com store (EU parent = product.bespoke.json,
  // US parent = product.bespoke-us.json). Regional behaviour is gated here, not forked.
  var REGION = (data.region === 'us') ? 'us' : 'eu';
  var IS_US = REGION === 'us';
  var EU_TOGGLE_SWITCH_TYPES = [
    { value: 'two-way', label: ST.twoWay || 'Two-way', filter: 'two-way',
      tooltip: ST.twoWayTip || 'Control the same light circuit from two locations (like the top and bottom of a staircase or in rooms with multiple entrances) using two of this type of switch.' },
    { value: 'centre-retractive', label: ST.centreRetractive || 'Centre Retractive', filter: 'centre retractive',
      tooltip: ST.centreRetractiveTip || 'A spring-return momentary switch that retracts to a neutral centre position. It can be pressed up or down to make two separate connections.' },
    { value: 'intermediate', label: ST.intermediate || 'Intermediate', filter: 'intermediate',
      tooltip: ST.intermediateTip || 'Used as part of a three-way circuit when more than two switches control the same light.\n\nTwo-way switches are used at the start and end of the circuit, and intermediate switches are added to the middle.' },
    { value: 'retractive', label: ST.retractive || 'Retractive', filter: 'retractive',
      tooltip: ST.retractiveTip || 'A spring-return momentary switch that retracts to a neutral top position.' }
  ];

  var EU_DIMMER_SWITCH_TYPES = [
    { value: 'two-way', label: ST.dimmerTwoWay || 'Two-way', filter: 'two-way',
      tooltip: ST.dimmerTwoWayTip || 'Use one two-way dimmer on a circuit to dim from one location. If you have a second switch on the circuit, it needs to be a two-way toggle or rocker.' },
    { value: 'multi-way', label: ST.multiway || 'Multiway', filter: 'multiway',
      tooltip: ST.multiwayTip || 'Use a multiway dimmer to dim the same light from multiple locations.' }
  ];

  // US electrical convention differs from EU's (UK "two-way"/"intermediate" ==
  // US "3-way"/"4-way"), and these values/filters must match real US SKU titles
  // ("Three Way Toggle Switch - Bronze" etc.) for productMatchesSwitchType's
  // title-substring fallback to ever resolve.
  var US_TOGGLE_SWITCH_TYPES = [
    { value: 'three-way', label: ST.threeWay || 'Three-Way', filter: 'three way',
      tooltip: ST.threeWayTip || 'Control the same light circuit from two locations (like the top and bottom of a staircase or in rooms with multiple entrances) using two of this type of switch.' },
    { value: 'four-way', label: ST.fourWay || 'Four-Way', filter: 'four way',
      tooltip: ST.fourWayTip || 'Used as part of a circuit when more than two switches control the same light.\n\nThree-way switches are used at the start and end of the circuit, and four-way switches are added to the middle.' },
    { value: 'double-pole', label: ST.doublePole || 'Double Pole', filter: 'double pole',
      tooltip: ST.doublePoleTip || 'Switches two circuits at once from a single switch action — useful when one switch needs to control two separate circuits together.' },
    { value: 'center-retractive', label: ST.centerRetractive || 'Center Retractive', filter: 'center retractive',
      tooltip: ST.centerRetractiveTip || 'A spring-return momentary switch that retracts to a neutral center position. It can be pressed up or down to make two separate connections.' },
    { value: 'retractive', label: ST.retractive || 'Retractive', filter: 'retractive',
      tooltip: ST.retractiveTip || 'A spring-return momentary switch that retracts to a neutral top position.' }
  ];

  var TOGGLE_SWITCH_TYPES = IS_US ? US_TOGGLE_SWITCH_TYPES : EU_TOGGLE_SWITCH_TYPES;
  // US dimmers have no static type list — their types derive per layout from the
  // products of the chosen finish (typesFromLayoutProducts), like sockets/keystones.
  var DIMMER_SWITCH_TYPES = IS_US ? null : EU_DIMMER_SWITCH_TYPES;

  // Socket/keystone tooltip copy, keyed by the stable bespoke.type_key metafield
  // (a title-independent join key — see typesFromLayoutProducts) rather than the
  // per-product bespoke.type_description/type_rating metafields. Moved to theme
  // content 2026-07-17 at the translation manager's request: Translate & Adapt
  // shows these as one flat, bulk-editable list instead of scattered one-product-
  // at-a-time metafield edits.
  var SOCKET_TYPE_TOOLTIPS = {
    'bipasso-2x': ST.bipasso2xTip || "This is the double version of our Bipasso socket, with two modules per 45mm aperture. It's used in Italy to power two household items.\n\n10A 230–250V input rating and 50Hz frequency.",
    'schuko-bipasso': ST.schukoBipassoTip || 'Used widely across mainland Europe to power household items.\n\n16A 230–250V input rating and 50Hz frequency.',
    'danish-type-k': ST.danishTypeKTip || 'Used primarily in Denmark, Greenland and parts of West Africa to power household items.\n\n13A 230–250V input rating and 50Hz frequency.',
    'schuko-type-f': ST.schukoTypeFTip || 'Used widely across mainland Europe to power household items.\n\n16A 230–250V input rating and 50Hz frequency.',
    'french-belgian-type-e': ST.frenchBelgianTypeETip || 'Used primarily in France, Belgium and Poland to power household items.\n\n16A 230–250V input rating and 50Hz frequency.',
    'swiss-type-j': ST.swissTypeJTip || 'Used primarily in Switzerland to power household items.\n\n10A 230–250V input rating and 50Hz frequency.',
    'bipasso-1x': ST.bipasso1xTip || "This is the single version of our Bipasso socket module. It's used in Italy to power household items.\n\n10A 230–250V input rating and 50Hz frequency.",
    'type-h': ST.typeHTip || 'Used primarily in Israel and the Palestinian territories to power household items.\n\n16A 230–250V input rating and 50Hz frequency.',
    'schuko-type-f-screwed': ST.schukoTypeFScrewedTip || "Used primarily in Spain to power household items. It's engineered with screw terminals for solid core and stranded cables up to 2.5mm in diameter.\n\n16A 230–250V input rating and 50Hz frequency.",
    // US outlet types
    'gfci-15a': ST.gfci15aTip || "A GFCI outlet constantly monitors the flow of electricity being carried to and away from a device. If there's an imbalance, it'll cut the power.\n\nIt's used in areas where there's a higher risk of electric shock.\n\n15A 125V~ input rating and 60Hz frequency.",
    'gfci-20a': ST.gfci20aTip || "A GFCI outlet constantly monitors the flow of electricity being carried to and away from a device. If there's an imbalance, it'll cut the power.\n\nIt's used in areas where there's a higher risk of electric shock.\n\n20A 125V~ input rating and 60Hz frequency.",
    'power-outlet-15a': ST.powerOutlet15aTip || "Used to power small household items that don't need a lot of electricity.\n\n15A 125V~ input rating and 60Hz frequency.",
    'power-outlet-20a': ST.powerOutlet20aTip || 'Used to power large household appliances that need more electricity.\n\n20A 125V~ input rating and 60Hz frequency.',
    'power-outlet-usb-15a': ST.powerOutletUsb15aTip || 'Used to power small household items and charge up to two USB-C devices at the same time.\n\n15A 125V~ input rating and 60Hz frequency.'
  };

  var KEYSTONE_TYPE_TOOLTIPS = {
    'cable-outlet-keystone': ST.cableOutletKeystoneTip || "Use this to hardwire any corded device that doesn't come fitted with a plug into the wall or connect your floor and table lamps to your switches.",
    'rj11-keystone': ST.rj11KeystoneTip || 'Use this for telephone and DSL connections.',
    'usb-c-30w': ST.usbC30wTip || 'Use this to fast charge up to two USB-C devices.',
    'usb-c-45w': ST.usbC45wTip || 'Use this to dual port to quickly charge up to two standard USB-C devices.',
    'usb-c-65w': ST.usbC65wTip || 'For charging up to two USB-C devices that require more power, such as larger laptops or high-performance tablets.\n\nThe devices will charge quicker using this version compared to our 45W option.',
    'tv-keystone': ST.tvKeystoneTip || 'Use this to connect your TV to the aerial using a coaxial cable.',
    'satellite-keystone': ST.satelliteKeystoneTip || 'Use this to connect your set-top box or another device to a satellite dish.',
    'hdmi-keystone': ST.hdmiKeystoneTip || 'Use this to connect displays (like TVs or monitors) to HDMI source devices (like computers or games consoles) directly through the wall for a tidier look.',
    'rj45-keystone': ST.rj45KeystoneTip || 'Use this to connect a computer, laptop or router to a fast Ethernet network.'
  };

  // US dimmers derive their type list from products; this keys their tooltip copy.
  var DIMMER_TYPE_TOOLTIPS = {
    'dimmer-three-way': ST.dimmerThreeWayTip || 'Use one three-way dimmer on a circuit to dim from one location. If you have a second switch on the circuit, it needs to be a three-way toggle or rocker.'
  };

  // Matches snippets/icon-tooltip.liquid (Step 1 style info buttons)
  var INFO_TOOLTIP_ICON = '<svg width="13" height="13" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">'
    + '<circle cx="11" cy="11" r="10" stroke="var(--background-foreground)" stroke-width="1.5"/>'
    + '<path d="M11 6V6.01" stroke="var(--background-foreground)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
    + '<path d="M11 10V16" stroke="var(--background-foreground)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>'
    + '</svg>';

  function renderModuleInfoBtn(tooltipText, ariaLabel) {
    if (!tooltipText) return '';
    // A <span> (not <button>) so it's valid inline inside a card <button> (#201 — the
    // switch-type (i) sits next to the name). role/tabindex keep it keyboard-focusable;
    // hover/click are delegated via closest('[data-info-tooltip]'), so tag doesn't matter.
    return '<span class="module-info-btn" role="button" tabindex="0" data-info-tooltip="' + escapeAttr(tooltipText) + '" aria-label="' + escapeAttr(ariaLabel) + '">' + INFO_TOOLTIP_ICON + '</span>';
  }

  var SWITCH_TYPES = {
    toggle: TOGGLE_SWITCH_TYPES,
    rocker: TOGGLE_SWITCH_TYPES,
    dimmer: DIMMER_SWITCH_TYPES
    // socket / outlet / keystone (and US dimmer, where DIMMER_SWITCH_TYPES is null):
    // derived per layout from products — see getSwitchTypes / typesFromLayoutProducts.
  };

  // ----------------------------------------------------------------
  // Init
  // ----------------------------------------------------------------

  function init() {
    normalizeLayouts();
    loadTaggedModules();
    initQuantitySelect();
    bindNavigation();
    bindOptionCards();
    bindSlotsContainer();
    bindResize();
    bindStickyLayout();
    updateUI();
  }

  var mobileStickyMq = window.matchMedia('(max-width: 768px)');

  function isMobileStickyLayout() {
    return mobileStickyMq.matches;
  }

  // #213 — track the last nav offset + a timer so we can flag a transient
  // "header shifting" window (the sticky preview/intro carry transition: top 0.3s)
  // and mask the strip they ease across. See .sb-nav-shifting in switch-builder.css.
  var sbPrevNavOffset = null;
  var sbNavShiftTimer = null;

  // Sticky `top` tracks the live navbar (including hide/show) via getBoundingClientRect().bottom.
  function getNavbarStickyOffset() {
    var navbar = document.querySelector('.navbar');
    if (!navbar) return 0;
    return Math.max(0, Math.round(navbar.getBoundingClientRect().bottom));
  }

  function updateStickyOffsets() {
    if (!builder) return;
    var navOffset = getNavbarStickyOffset();

    if (isMobileStickyLayout()) {
      builder.style.setProperty('--sb-sticky-top', navOffset + 'px');
      builder.style.removeProperty('--sb-desktop-sticky-top');
      builder.style.removeProperty('--sb-builder-height');
      if (!previewPanel) return;
      var previewHeight = previewPanel.getBoundingClientRect().height;
      builder.style.setProperty(
        '--sb-sticky-intro-top',
        (navOffset + Math.ceil(previewHeight)) + 'px'
      );
      // #213 — nav showed/hid: flag the shift window so the intro mask covers the
      // strip the header eases across (the page text behind it would otherwise
      // bleed through). Deterministic class + timeout, not scroll-timing.
      if (sbPrevNavOffset !== null && navOffset !== sbPrevNavOffset) {
        builder.classList.add('sb-nav-shifting');
        if (sbNavShiftTimer) clearTimeout(sbNavShiftTimer);
        sbNavShiftTimer = setTimeout(function () {
          builder.classList.remove('sb-nav-shifting');
          sbNavShiftTimer = null;
        }, 360);
      }
      sbPrevNavOffset = navOffset;
      return;
    }

    builder.style.setProperty('--sb-desktop-sticky-top', navOffset + 'px');
    builder.style.removeProperty('--sb-sticky-top');
    builder.style.removeProperty('--sb-sticky-intro-top');
    // Leaving the mobile sticky layout — drop the shift flag so it can't linger.
    sbPrevNavOffset = null;
    if (sbNavShiftTimer) {
      clearTimeout(sbNavShiftTimer);
      sbNavShiftTimer = null;
    }
    builder.classList.remove('sb-nav-shifting');

    // Publish the image height so the steps column can match it (the fixed-height
    // builder: header pinned top, footer pinned bottom, options scroll between).
    if (previewPanel) {
      builder.style.setProperty(
        '--sb-builder-height',
        Math.round(previewPanel.getBoundingClientRect().height) + 'px'
      );
    }
    updateStepScrollFade();
  }

  function scheduleStickyUpdate() {
    requestAnimationFrame(updateStickyOffsets);
  }

  function bindStickyLayout() {
    if (!previewPanel) return;

    if (typeof ResizeObserver !== 'undefined') {
      var previewObserver = new ResizeObserver(scheduleStickyUpdate);
      previewObserver.observe(previewPanel);
    }

    var navbar = document.querySelector('.navbar');
    if (navbar && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(scheduleStickyUpdate).observe(navbar);
    }
    if (navbar && typeof MutationObserver !== 'undefined') {
      new MutationObserver(scheduleStickyUpdate).observe(navbar, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }

    var scrollTicking = false;
    window.addEventListener('scroll', function () {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(function () {
        updateStickyOffsets();
        scrollTicking = false;
      });
    }, { passive: true });

    var onMqChange = scheduleStickyUpdate;
    if (mobileStickyMq.addEventListener) {
      mobileStickyMq.addEventListener('change', onMqChange);
    } else if (mobileStickyMq.addListener) {
      mobileStickyMq.addListener(onMqChange);
    }

    scheduleStickyUpdate();
  }

  function parseEngravingWidthsMm(raw) {
    if (raw == null || raw === '') return [];
    if (Array.isArray(raw)) {
      return raw.map(function (v) { return Number(v); }).filter(function (n) { return isFinite(n) && n > 0; });
    }
    if (typeof raw === 'number') return isFinite(raw) && raw > 0 ? [raw] : [];
    var s = String(raw).trim();
    if (!s) return [];
    if (s.charAt(0) === '[') {
      try {
        var parsed = JSON.parse(s);
        if (Array.isArray(parsed)) return parseEngravingWidthsMm(parsed);
      } catch (err) { /* fall through to comma split */ }
    }
    return s.replace(/[\[\]"']/g, '').split(/[,;]/).map(function (part) {
      return Number(String(part).trim());
    }).filter(function (n) { return isFinite(n) && n > 0; });
  }

  // Modules the visitor's market can't buy (sold out with "stop selling") would only fail at
  // add-to-cart with a 422, so they never reach the picker. `available` comes from
  // snippets/switch-builder-module-json.liquid; an older payload without it keeps the module.
  // Products that carry a module tag but aren't plate modules (in-line dimmers) are listed by
  // SKU in the section's excluded_module_skus setting; SKUs, unlike titles/handles, don't change
  // per locale.
  var EXCLUDED_MODULE_SKUS = String(data.excludedModuleSkus || '').split(',').map(function (s) {
    return s.trim().toUpperCase();
  }).filter(Boolean);

  function buyableModules(products) {
    return (products || []).filter(function (p) {
      return p && p.available !== false
        && EXCLUDED_MODULE_SKUS.indexOf(String(p.sku || '').trim().toUpperCase()) === -1;
    });
  }

  function normalizeLayouts() {
    data.layouts = (data.layouts || []).filter(function (layout) {
      var key = normalizeCategoryKey(layout.category);
      if (!key) return false;
      layout.categoryKey = key;
      if (Array.isArray(layout.products)) layout.products = buyableModules(layout.products);
      layout.engravingMaxWidthsMm = parseEngravingWidthsMm(layout.engravingMaxWidthsMm);
      layout.engravingMaxWidthSingleMm = Number(layout.engravingMaxWidthSingleMm) || 0;
      layout.engravingMaxWidthHalfMm = Number(layout.engravingMaxWidthHalfMm) || 0;
      layout.engravingAboveOffsetMm = plateOffsetMm(layout.engravingAboveOffsetMm);
      layout.engravingBelowOffsetMm = plateOffsetMm(layout.engravingBelowOffsetMm);
      // EU layouts carry a boolean `pairable`; US layouts carry an integer `slot_capacity`
      // (emitted separately as slotCapacity). Either marks the layout as splittable /
      // stackable. NOT slotsRequired: EU inline double modules (double rocker) have
      // slots_required 2 with pairable false and must not get the split UI.
      layout.slotCapacity = Number(layout.slotCapacity) || 0;
      layout.pairable = !!layout.pairable || layout.slotCapacity > 1;
      // bespoke_layout.stack_direction: 'horizontal' (EU side-by-side pairs) or 'vertical'
      // (US keystones stack on top of one another in one gang position). When the entry
      // has no value, default by region — every US stacking layout is vertical.
      if (layout.stackDirection !== 'vertical' && layout.stackDirection !== 'horizontal') {
        layout.stackDirection = IS_US ? 'vertical' : 'horizontal';
      }
      return true;
    });
  }

  // A layout with no products collection carries productsUrls instead: the automatic
  // /collections/all filtered by its ProductCollection tag and each colour-suffixed variant of it
  // (+ live-warehouse tag), rendered as JSON by templates/collection.builder-modules.liquid.
  // Fetched once at start-up, one request per distinct URL; a layout's lists are merged in URL
  // order, de-duplicated by variant id. Step 2 shows a loading state until every list has landed:
  // module drafts copy layout.products when a position is opened, and the sole-match
  // auto-pick runs on click, so neither may run against a list that is still empty.
  // No Accept: application/json header — Shopify answers that on a collection URL with its
  // own JSON format, which 404s for tag-filtered URLs.
  var modulesLoading = 0;
  var modulesFailed = false;

  // Variant id -> lowercased English "title handle", fetched from the market's English version
  // (layout.englishTitlesUrls, set only on non-English storefronts). Translate & Adapt translates
  // module titles and handles, so the English switch-type/finish words match nothing on /de-de/
  // without it. Used for matching only; prices and stock come from the visitor's own list.
  var englishMatchText = {};

  function englishText(product) {
    return (product && englishMatchText[String(product.id)]) || '';
  }

  function mergeTaggedModules(layout, listsByUrl) {
    var seen = {};
    var merged = [];
    layout.productsUrls.forEach(function (url) {
      (listsByUrl[url] || []).forEach(function (product) {
        if (seen[product.id]) return;
        seen[product.id] = true;
        merged.push(product);
      });
    });
    layout.products = buyableModules(merged);
  }

  // The tags part of a /collections/all/<tag>+<tag> URL.
  function urlTagSegment(url) {
    // Sorted, so Shopify's redirect to the alphabetical tag order doesn't count as a dropped tag.
    var m = String(url).match(/\/collections\/all\/([^?#]*)/);
    return m ? decodeURIComponent(m[1]).toLowerCase().split('+').sort().join('+') : '';
  }

  // Fetches a tag-filtered JSON view. Shopify 301s a URL tag that no product in the shop carries
  // to the same URL without it (…/all/warehousepl-3-live), which would return every live product;
  // a redirect that changed the tags therefore resolves to null (no products) with a warning.
  function fetchTaggedJson(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      if (res.redirected && urlTagSegment(res.url) !== urlTagSegment(url)) {
        if (window.console) console.warn('switch-builder: no product carries a tag in ' + url + ' (Shopify redirected to ' + res.url + '). Check the bespoke_layout module_tags.');
        return null;
      }
      return res.json();
    });
  }

  function loadTaggedModules() {
    var byUrl = {};
    var listsByUrl = {};
    var titleUrls = {};
    (data.layouts || []).forEach(function (layout) {
      if (!layout.productsUrls || !layout.productsUrls.length || (layout.products && layout.products.length)) return;
      layout.productsUrls.forEach(function (url) {
        (byUrl[url] = byUrl[url] || []).push(layout);
      });
      // englishTitlesUrls are root-less (/collections/…); data.englishRoot is 'en-de', or '' for
      // the bare root. Joined here because Shopify rewrites a rendered /en-de/ path to /de-de/.
      if (typeof data.englishRoot === 'string') {
        (layout.englishTitlesUrls || []).forEach(function (url) {
          titleUrls[(data.englishRoot ? '/' + data.englishRoot : '') + url] = true;
        });
      }
    });
    // English titles: a failure only costs translated-storefront matching (the title/handle
    // heuristic still runs), so it warns rather than setting modulesFailed.
    Object.keys(titleUrls).forEach(function (url) {
      modulesLoading++;
      fetchTaggedJson(url)
        .then(function (json) {
          var titles = (json && json.titles) || {};
          Object.keys(titles).forEach(function (id) {
            englishMatchText[id] = String(titles[id] || '').toLowerCase();
          });
        })
        .catch(function (err) {
          if (window.console) console.warn('switch-builder: English module titles did not load from ' + url, err);
        })
        .then(modulesLoaded);
    });
    Object.keys(byUrl).forEach(function (url) {
      modulesLoading++;
      fetchTaggedJson(url)
        .then(function (json) {
          listsByUrl[url] = (json && Array.isArray(json.products)) ? json.products : [];
          byUrl[url].forEach(function (layout) { mergeTaggedModules(layout, listsByUrl); });
        })
        .catch(function (err) {
          modulesFailed = true;
          if (window.console) console.warn('switch-builder: modules did not load from ' + url, err);
        })
        .then(modulesLoaded);
    });
  }

  function modulesLoaded() {
    modulesLoading--;
    if (modulesLoading === 0) warnEmptyTaggedLayouts();
    if (modulesLoading === 0 && state.step === 2) {
      renderModuleSlots();
      updateUI();
    }
  }

  // A tag-fetched layout that loaded fine but came back empty usually means its tags no longer
  // match the products (a retag, or a typo in the bespoke_layout's module_tags). Its category is
  // hidden (categoryHasModules); this says why, for whoever is debugging.
  function warnEmptyTaggedLayouts() {
    if (modulesFailed || !window.console) return;
    (data.layouts || []).forEach(function (layout) {
      if (!layout.productsUrls || !layout.productsUrls.length || (layout.products && layout.products.length)) return;
      console.warn('switch-builder: no buyable modules for the "' + layout.categoryKey + '" layout, so the category is hidden. '
        + 'Check the bespoke_layout module_tags against the products\' tags. Fetched: ' + layout.productsUrls.join(' , '));
    });
  }

  // A category is offered only if one of its layouts has buyable modules. Categories with no
  // layout at all are left as they were.
  function categoryHasModules(categoryKey) {
    var layouts = getLayoutsForCategory(normalizeCategoryKey(categoryKey));
    if (!layouts.length) return true;
    return layouts.some(function (l) { return l.products && l.products.length; });
  }

  // Step 2 placeholder while tag-fetched module lists load, or if one failed.
  function renderModulesStatus() {
    if (modulesLoading === 0 && !modulesFailed) return false;
    slotsContainer.innerHTML = '<p class="builder-modules-status font-type-5">'
      + (modulesFailed
        ? (I18N.modulesFailed || 'We couldn\'t load the modules. Please refresh the page to try again.')
        : (I18N.modulesLoading || 'Loading modules…'))
      + '</p>';
    return true;
  }

  function normalizeCategoryKey(raw) {
    return String(raw || '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  }

  function isSplitLayout(layout) {
    return !!(layout && layout.pairable);
  }

  // A double-width module (bespoke.double_width) fills a whole position on its
  // own — it can't sit LEFT/RIGHT next to another module, so paired/split picks
  // must exclude it. Single (unsplit) picks are unaffected.
  function excludeDoubleWidthModules(products) {
    return (products || []).filter(function (p) { return !p.doubleWidth; });
  }

  /** Split cart UI (LEFT/RIGHT) — pairable layouts only, not inline double-rocker modules. */
  function isSplitLayoutForDraft(draft) {
    if (!draft || !draft.layout) return false;
    if (!isSplitLayout(draft.layout)) return false;
    if (draft.layoutMode === 'single') return false;
    return true;
  }

  function productUsesInlineDoubleEngraving(product) {
    return !!(product && product.inlineDoubleEngraving);
  }

  function moduleUsesInlineDoubleEngraving(moduleObj) {
    if (!moduleObj) return false;
    if (moduleObj.inlineDoubleEngraving) return true;
    return moduleObj.inlineSplitEngraving || moduleObj.engravingMode === 'inline-double';
  }

  function getSwitchTypes(categoryKey, layout, moduleFinish) {
    var staticTypes = SWITCH_TYPES[categoryKey];
    if (staticTypes && staticTypes.length) return staticTypes;
    if ((isInsertCategory(categoryKey) || categoryKey === 'dimmer') && layout) {
      return typesFromLayoutProducts(layout, moduleFinish, categoryKey);
    }
    return [];
  }

  // Drop everything from the first ' - ' (hyphen / en-dash / em-dash) onward — the
  // finish/insert-colour suffix on a product title. Language-agnostic (no word match),
  // so it works on translated storefronts. e.g. "Schuko/Bipasso Socket - Black"
  // -> "Schuko/Bipasso Socket". (BugHerd #204)
  function stripFinishSuffix(title) {
    return String(title || '').split(/\s[-–—]\s/)[0].trim();
  }

  // Looks up tooltip copy by the stable bespoke.type_key metafield (theme content,
  // rating as its own paragraph, same \n\n convention as the switch-type tips —
  // .module-info-tooltip already renders it via white-space: pre-line). Falls back
  // to the legacy per-product bespoke.type_description/type_rating metafields for
  // any product not yet carrying a type_key (rollout safety net — remove once every
  // socket/keystone product has one written).
  function typeTooltipText(p) {
    var mapped = SOCKET_TYPE_TOOLTIPS[p.typeKey] || KEYSTONE_TYPE_TOOLTIPS[p.typeKey] || DIMMER_TYPE_TOOLTIPS[p.typeKey];
    if (mapped) return mapped;
    var parts = [];
    if (p.typeDescription) parts.push(p.typeDescription);
    if (p.typeRating) parts.push(p.typeRating);
    return parts.join('\n\n');
  }

  function typesFromLayoutProducts(layout, moduleFinish, categoryKey) {
    var seen = {};
    var types = [];
    var products = layout.products || [];
    // Filter to the already-chosen finish first (insert colour for socket/outlet/keystone,
    // metal finish for a product-derived dimmer list) — otherwise a category with one
    // product per finish would produce duplicate-looking cards, one per finish variant.
    if (moduleFinish) {
      products = products.filter(function (p) {
        return productMatchesModuleFinish(p, moduleFinish, categoryKey);
      });
    }
    products.forEach(function (p) {
      var fullTitle = (p.title || '').trim();
      if (!fullTitle || seen[fullTitle]) return;
      seen[fullTitle] = true;
      types.push({
        value: slugify(fullTitle),
        // #204: drop the redundant " - <insert colour>" suffix from the displayed label
        // (colour is already chosen a step earlier). value/filter keep the full title so
        // matching + persisted keys are unchanged.
        label: stripFinishSuffix(fullTitle),
        filter: fullTitle.toLowerCase(),
        tooltip: typeTooltipText(p)
      });
    });
    types.sort(function (a, b) {
      return a.label.localeCompare(b.label);
    });
    return types;
  }

  function slugify(str) {
    return String(str || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  // Scale factor for engraving text depends on the rendered image
  // width, so a viewport resize (or a layout reflow on e.g. an orientation
  // change) needs to rescale. Debounced to avoid hammering on drag.
  function bindResize() {
    var t = null;
    window.addEventListener('resize', function () {
      if (t) clearTimeout(t);
      t = setTimeout(function () {
        scheduleStickyUpdate();
        if (state.engraving.enabled || state.step === 3) {
          scaleEngravingOverlays();
        }
      }, 120);
    });
  }

  // ----------------------------------------------------------------
  // Navigation
  // ----------------------------------------------------------------

  function bindNavigation() {
    nextBtn.addEventListener('click', handleNext);
    backBtn.addEventListener('click', handleBack);

    if (startBtn) {
      startBtn.addEventListener('click', function () {
        goToStep(1);
      });
    }

    if (quantitySelect) {
      quantitySelect.addEventListener('change', function () {
        state.quantity = Math.max(1, Math.min(99, parseInt(quantitySelect.value, 10) || 1));
        syncQuantityUI();
        // The stock-plate match depends on quantity (stock must cover it), so the review
        // plate line, price and stock status must follow — they were left stale before.
        if (state.step === state.totalSteps) renderReview();
        updateUI();
      });
    }
    if (termsCheckbox) {
      termsCheckbox.addEventListener('change', function () {
        state.termsAccepted = termsCheckbox.checked;
        if (state.step === 4) updateUI();
      });
    }
    if (reviewContent) {
      reviewContent.addEventListener('click', handleReviewClick);
    }
  }

  function initQuantitySelect() {
    if (!quantitySelect) return;
    quantitySelect.innerHTML = '';
    for (var q = 1; q <= 99; q++) {
      var opt = document.createElement('option');
      opt.value = String(q);
      opt.textContent = String(q);
      quantitySelect.appendChild(opt);
    }
    syncQuantityUI();
  }

  function syncQuantityUI() {
    if (quantitySelect) quantitySelect.value = String(state.quantity);
  }

  function handleReviewClick(e) {
    var btn = e.target.closest('[data-review-change]');
    if (!btn) return;
    e.preventDefault();
    var target = btn.dataset.reviewChange;
    if (target === 'plate') {
      goToStep(1);
    } else if (target === 'engraving') {
      goToStep(3);
    } else if (target.indexOf('position-') === 0) {
      expandedSlot = parseInt(target.replace('position-', ''), 10) || 1;
      // Hydrate the editor from the committed slot, exactly as the in-step expand
      // button does — otherwise "Change" from the review page opened an empty draft
      // and every pick (all parts of a stack, and their _pickMeta) had to be redone.
      var committedForChange = state.slots[expandedSlot];
      ensureSlotDraft(expandedSlot, committedForChange);
      if (committedForChange && isSlotComplete(committedForChange)) {
        slotDrafts[expandedSlot]._reconfiguring = true;
        slotDrafts[expandedSlot]._edited = false;
      }
      goToStep(2);
    }
  }

  function handleNext() {
    if (state.step === state.totalSteps) {
      if (justAdded) {
        resetBuilder();
      } else {
        handleAddToCart();
      }
      return;
    }
    if (state.step === 3) {
      syncEngravingEnabledFromValues();
    }
    if (!validateStep(state.step)) return;
    goToStep(state.step + 1);
  }

  function handleBack() {
    if (state.step <= 1) return;
    goToStep(state.step - 1);
  }

  function goToStep(n) {
    // Any navigation exits the post-add "Build another" mode, so editing the
    // config (via a Review "Change" link) restores the "Add to basket" button.
    justAdded = false;
    state.step = n;
    if (n === 2) {
      renderModuleSlots();
    }
    if (n === 3) renderEngravingStep();
    if (n === 4) renderReview();
    updateUI();
    scheduleStickyUpdate();
    scrollToBuilder();
  }

  function firstIncompleteSlot() {
    for (var i = 1; i <= (state.gangCount || 0); i++) {
      if (!isSlotComplete(state.slots[i])) return i;
    }
    return null;
  }

  function orientationRequired() {
    if (!orientationGroup || !orientationGroup.querySelector('.option-card[data-value]')) {
      return false;
    }
    return Object.keys(data.plateVariants).some(function (key) {
      return key.split('|').length >= 4;
    });
  }

  function validateStep(n) {
    switch (n) {
      case 1:
        return !!state.style && !!state.finish && !!state.size
          && (!orientationRequired() || !!state.orientation)
          && !!getPlateVariant();
      case 2: return allSlotsSelected() && !hasUnfinishedEdit();
      case 3: return state.engraving.validityErrors === 0;
      case 4:
        return !termsRequired || state.termsAccepted;
      default: return true;
    }
  }

  function allSlotsSelected() {
    if (!state.gangCount) return false;
    for (var i = 1; i <= state.gangCount; i++) {
      var slot = state.slots[i];
      if (!slot) return false;
      if (slot.split && !halfKeysForSlot(slot).every(function (k) { return !!slot[k]; })) return false;
    }
    // At least one position must be cut (a module or a cutout) — an all-blank plate is
    // just the regular blank plate. canSkipPosition() already stops the UI getting here.
    return hasCutPosition();
  }

  function isSplit(slot) {
    return !!(slot && slot.split);
  }

  function scrollToBuilder() {
    if (!isMobileStickyLayout()) return;
    var top = builder.getBoundingClientRect().top + window.scrollY - 20;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function getScrollPaddingTop() {
    if (isMobileStickyLayout()) {
      updateStickyOffsets();
      var introTop = builder.style.getPropertyValue('--sb-sticky-intro-top');
      if (introTop) return parseFloat(introTop) + 12;
      return getNavbarStickyOffset()
        + (previewPanel ? previewPanel.getBoundingClientRect().height : 0)
        + 12;
    }
    updateStickyOffsets();
    var nav = getNavbarStickyOffset();
    var intro = builder.querySelector('.builder-step-panel.active .builder-plate-intro--pinned');
    var introHeight = intro ? intro.getBoundingClientRect().height : 0;
    return nav + introHeight + 16;
  }

  // Keep the active position (and newly revealed options) in view on mobile only.
  function scrollPositionSlotIntoView(slotNum, focusSelector) {
    if (!isMobileStickyLayout()) return;
    if (state.step !== 2 || !slotsContainer || !slotNum) return;

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var section = slotsContainer.querySelector('[data-slot-num="' + slotNum + '"]');
        if (!section) return;

        var focus;
        if (focusSelector) {
          focus = section.querySelector(focusSelector);
        } else {
          // Scroll to the first option that still needs a choice, not the last
          // subsection — otherwise picking one option drops the user straight
          // past later ones (e.g. the insert-colour select). A .module-subsection
          // with no .selected card is the next thing to fill in.
          var subsections = section.querySelectorAll('.position-slot-body .module-subsection');
          for (var i = 0; i < subsections.length; i++) {
            if (!subsections[i].querySelector('.selected')) {
              focus = subsections[i];
              break;
            }
          }
          // Everything chosen already — fall back to the last subsection.
          if (!focus) {
            focus = section.querySelector('.position-slot-body .module-subsection:last-child');
          }
        }
        var el = focus || section;
        var rect = el.getBoundingClientRect();
        var headerBottom = getScrollPaddingTop();
        var viewportBottom = window.innerHeight;
        var PAD = 12;
        // The builder used to align the next subsection to the top of the content on
        // every pick, so the page scrolled on each selection even when the next choice
        // was already on screen — it read as "jumping around" (and step 1, which never
        // scrolls, felt steady by comparison). Only move when the next choice isn't
        // already comfortably between the sticky header and the fold, and then by the
        // minimum needed — never upward (BugHerd #211), and instantly (a smooth scroll
        // stacked badly with the sticky header's `transition: top` + the iOS address bar).
        if (rect.top < headerBottom) return;            // hidden under the header → would scroll UP; skip (#211)
        if (rect.bottom <= viewportBottom) return;      // already fully in view → don't move
        // Below the fold: drop down, but err on revealing too LITTLE rather than too much
        // (Michael, 2026-06-22). The old min(reveal-its-bottom, align-top-to-header) still
        // hoisted a tall subsection's top all the way up to the sticky header line — a big
        // jump that read as "dropped too far down". Add a third cap: never drop more than
        // enough to peek REVEAL px of the next choice into the bottom of the viewport, so a
        // tall subsection just edges into view and the user scrolls the rest if they want.
        // The peek term also no-ops us when that much is already showing (peekDelta <= 0).
        // Still never upward (#211) and instant. REVEAL is derived from the visible content
        // gap (35%, clamped 80–140px) rather than a flat 140 so it can't exceed the gap on a
        // cramped viewport — which would otherwise leave the target barely revealed (GPT review).
        var visibleHeight = viewportBottom - headerBottom;
        var REVEAL = Math.max(80, Math.min(140, visibleHeight * 0.35));
        var peekDelta = rect.top - (viewportBottom - REVEAL);
        var delta = Math.min(rect.bottom - viewportBottom + PAD, rect.top - headerBottom, peekDelta);
        if (delta <= 0) return;
        window.scrollTo({ top: window.scrollY + delta });
      });
    });
  }

  function updateLongListScrollFades() {
    if (!slotsContainer) return;
    slotsContainer.querySelectorAll('.module-option-grid-scroll').forEach(function (wrap) {
      var grid = wrap.querySelector('.module-option-grid--long-list');
      if (!grid) return;
      function sync() {
        var atEnd = grid.scrollTop + grid.clientHeight >= grid.scrollHeight - 8;
        wrap.classList.toggle('module-option-grid-scroll--at-end', atEnd);
        wrap.classList.toggle('module-option-grid-scroll--scrollable', grid.scrollHeight > grid.clientHeight + 4);
      }
      if (!grid.dataset.scrollFadeBound) {
        grid.dataset.scrollFadeBound = '1';
        grid.addEventListener('scroll', sync, { passive: true });
      }
      sync();
    });
  }

  // ----------------------------------------------------------------
  // UI update
  // ----------------------------------------------------------------

  // Bottom-fade hint on the desktop fixed-height builder's scrollable middle.
  // Mirrors updateLongListScrollFades: toggle classes the CSS ::after keys off.
  function updateStepScrollFade() {
    if (!builder) return;
    var panel = builder.querySelector('.builder-step-panel.active');
    if (!panel) return;
    var scroller = panel.querySelector('.builder-step-scroll');
    if (!scroller) return;

    // Desktop only — on mobile the page scrolls, so clear any fade classes.
    if (isMobileStickyLayout()) {
      panel.classList.remove(
        'builder-step-panel--scrollable',
        'builder-step-panel--scroll-end'
      );
      return;
    }

    function sync() {
      var scrollable = scroller.scrollHeight > scroller.clientHeight + 4;
      var atEnd =
        scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 8;
      panel.classList.toggle('builder-step-panel--scrollable', scrollable);
      panel.classList.toggle('builder-step-panel--scroll-end', atEnd);
    }
    if (!scroller.dataset.stepFadeBound) {
      scroller.dataset.stepFadeBound = '1';
      scroller.addEventListener('scroll', sync, { passive: true });
    }
    sync();
  }

  function updateUI() {
    stepPanels.forEach(function (panel) {
      panel.classList.toggle('active', parseInt(panel.dataset.step) === state.step);
    });

    backBtn.classList.toggle('visible', state.step > 1 && state.step < state.totalSteps);

    // The front page has its own Start button — no back/next/price footer.
    if (navBar) {
      navBar.hidden = state.step === 0;
      navBar.dataset.step = String(state.step);
      navBar.classList.toggle('builder-nav-bar--review', state.step === state.totalSteps);
    }
    if (navFooter) {
      navFooter.classList.toggle('builder-nav-footer--review', state.step === state.totalSteps);
    }

    if (state.step === state.totalSteps) {
      nextBtn.textContent = justAdded
        ? (I18N.buildAnother || 'Build another')
        : (I18N.addToBasket || 'Add to basket');
      // "Build another" is a neutral reset action, so it takes the neutral
      // (secondary) button colours; "Add to basket" keeps the primary
      // purchase colours. Layout is unchanged (.builder-next-btn handles size).
      nextBtn.classList.toggle('secondary-btn', justAdded);
      nextBtn.classList.toggle('primary-btn', !justAdded);
      if (quantityWrap) {
        quantityWrap.removeAttribute('hidden');
        quantityWrap.hidden = false;
      }
    } else {
      nextBtn.textContent = I18N.next || 'Next';
      nextBtn.classList.add('secondary-btn');
      nextBtn.classList.remove('primary-btn');
      if (quantityWrap) {
        quantityWrap.hidden = true;
        quantityWrap.setAttribute('hidden', '');
      }
    }

    // "Build another" (Review step, post-add) is always actionable; otherwise
    // gate on the step's validity. Scoped to the final step so an add-in-flight
    // race can't leave an earlier step's "Next" wrongly enabled.
    nextBtn.disabled = (state.step === state.totalSteps && justAdded)
      ? false
      : !validateStep(state.step);

    updatePriceDisplay();
    priceContainer.classList.add('visible');

    updateFinishAvailability();
    updatePlateAvailability();
    updatePlateOptionProgress();
    syncAllOptionGroupFades();
    updateStockStatus();
    updateStockNotice();
    updatePreview();
    updateStepScrollFade();
  }

  var PAINTABLE_FINISH = 'paintable';
  var GROVE_STYLE = 'grove';
  var KEW_STYLE = 'kew';

  function setOptionUnavailable(card, unavailable) {
    if (!card) return;
    card.classList.toggle('option-card--unavailable', unavailable);
    card.disabled = unavailable;
    card.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
  }

  function selectStyleCard(styleValue) {
    var group = builder.querySelector('.option-cards[data-group="style"]');
    if (!group) return;
    group.querySelectorAll('.option-card').forEach(function (c) {
      c.classList.remove('selected');
    });
    var card = group.querySelector('.option-card[data-value="' + styleValue + '"]');
    if (card && !card.disabled) {
      card.classList.add('selected');
      state.style = styleValue;
    }
  }

  function clearFinishCard(finishValue) {
    var card = builder.querySelector('.option-card--finish[data-value="' + finishValue + '"]');
    if (card) card.classList.remove('selected');
    if (state.finish === finishValue) state.finish = null;
  }

  // Paintable ↔ Grove are mutually exclusive. Grove hides Kew-only finishes (incl. Paintable).
  function updateFinishAvailability() {
    var paintableSelected = state.finish === PAINTABLE_FINISH;
    var groveSelected = state.style === GROVE_STYLE;
    var finishGroup = builder.querySelector('.option-cards[data-group="finish"]');

    var groveStyleCard = builder.querySelector('.option-card--style[data-value="' + GROVE_STYLE + '"]');
    setOptionUnavailable(groveStyleCard, paintableSelected);

    if (paintableSelected && groveSelected) {
      groveStyleCard.classList.remove('selected');
      selectStyleCard(KEW_STYLE);
      groveSelected = false;
    }

    builder.querySelectorAll('.option-card--finish').forEach(function (card) {
      var isKewOnly = card.hasAttribute('data-kew-only');
      var hideWhenGrove = groveSelected && isKewOnly;

      card.hidden = hideWhenGrove;
      setOptionUnavailable(card, false);

      if (hideWhenGrove && card.classList.contains('selected')) {
        card.classList.remove('selected');
        if (state.finish === card.dataset.value) state.finish = null;
      }
    });

    if (groveSelected && paintableSelected) {
      clearFinishCard(PAINTABLE_FINISH);
    }

    if (finishGroup) {
      finishGroup.classList.toggle('option-cards--finish-three', groveSelected);
      syncOptionGroupFade(finishGroup);
    }
    updateSizeAvailability();
  }

  // A size card shows only when the plate map has a plate for the chosen style + finish + size
  // (with or without an orientation suffix). One page serves Kew and Grove — Italy has EU Kew
  // single/double/triple and Italian Grove 3-module/4-module — and it also hides sizes a finish
  // isn't made in (Satin Nickel gaps). A hidden selected size is cleared.
  function updateSizeAvailability() {
    var sizeGroup = builder.querySelector('.option-cards[data-group="size"]');
    if (!sizeGroup) return;
    var keys = Object.keys(data.plateVariants || {});
    sizeGroup.querySelectorAll('.option-card--gang').forEach(function (card) {
      var show = true;
      if (state.style && state.finish) {
        var base = state.style + '|' + state.finish + '|' + card.dataset.value;
        show = keys.some(function (k) { return k === base || k.indexOf(base + '|') === 0; });
      }
      card.hidden = !show;
      if (!show && card.classList.contains('selected')) {
        clearSizeSelection();
        clearOrientationSelection();
      }
    });
    syncOptionGroupFade(sizeGroup);
  }

  // Step 1 only offers combinations with a buyable plate (GPT review 2026-10-13): sizes come
  // from the plate-geometry metaobjects, not from plateVariants, so without this a customer
  // could pick e.g. a finish/size Oskar hasn't created yet, reach Review with no plate price
  // and have Add to basket do nothing. Runs after updateFinishAvailability, which resets the
  // finish cards, so it only ever adds unavailability there. Changing an upstream option
  // already clears everything downstream, so no selection is left on a disabled card.
  function updatePlateAvailability() {
    builder.querySelectorAll('.option-cards[data-group="style"] .option-card[data-value]').forEach(function (card) {
      if (!plateExists(card.dataset.value)) setOptionUnavailable(card, true);
    });
    builder.querySelectorAll('.option-cards[data-group="finish"] .option-card[data-value]').forEach(function (card) {
      if (state.style && !plateExists(state.style, card.dataset.value)) setOptionUnavailable(card, true);
    });
    builder.querySelectorAll('.option-cards[data-group="size"] .option-card[data-value]').forEach(function (card) {
      setOptionUnavailable(card, !!(state.style && state.finish)
        && !plateExists(state.style, state.finish, card.dataset.value));
    });
    builder.querySelectorAll('.option-cards[data-group="orientation"] .option-card[data-value]').forEach(function (card) {
      setOptionUnavailable(card, !!(state.style && state.finish && state.size)
        && !plateExists(state.style, state.finish, state.size, card.dataset.value));
    });
  }

  function syncOptionGroupFade(group) {
    if (!group) return;
    var visibleCards = Array.prototype.filter.call(
      group.querySelectorAll('.option-card'),
      function (card) { return !card.hidden; }
    );
    var hasSelected = visibleCards.some(function (card) {
      return card.classList.contains('selected');
    });
    group.classList.toggle('option-cards--has-selection', hasSelected);
  }

  function syncAllOptionGroupFades() {
    builder.querySelectorAll('.option-cards[data-group]').forEach(syncOptionGroupFade);
  }

  function clearFinishSelection() {
    state.finish = null;
    builder.querySelectorAll('.option-card--finish.selected').forEach(function (card) {
      card.classList.remove('selected');
    });
    var finishCards = builder.querySelector('.option-cards[data-group="finish"]');
    if (finishCards) syncOptionGroupFade(finishCards);
  }

  function clearSizeSelection() {
    state.size = null;
    state.sizeLabel = null;
    state.gangCount = null;
    state.slots = {};
    slotDrafts = {};
    expandedSlot = null;
    resetEngraving();
    var sizeCards = builder.querySelector('.option-cards[data-group="size"]');
    if (sizeCards) {
      sizeCards.querySelectorAll('.option-card.selected').forEach(function (card) {
        card.classList.remove('selected');
      });
      syncOptionGroupFade(sizeCards);
    }
  }

  function clearOrientationSelection() {
    state.orientation = null;
    var orientCards = builder.querySelector('.option-cards[data-group="orientation"]');
    if (orientCards) {
      orientCards.querySelectorAll('.option-card.selected').forEach(function (card) {
        card.classList.remove('selected');
      });
      syncOptionGroupFade(orientCards);
    }
  }

  // Step 1 — reveal plate options one at a time (style → finish → size → orientation).
  function updatePlateOptionProgress() {
    if (state.step !== 1) return;

    var showFinish = !!state.style;
    var showSize = showFinish && !!state.finish;
    var showOrientation = showSize && !!state.size && !!orientationGroup;

    if (finishGroupEl) {
      finishGroupEl.hidden = !showFinish;
    }
    if (sizeGroupEl) {
      sizeGroupEl.hidden = !showSize;
    }
    if (orientationGroup) {
      orientationGroup.hidden = !showOrientation;
    }
  }

  function isModuleFinishUnavailable(finish) {
    return !!(finish.kewOnly && state.style === GROVE_STYLE);
  }

  // ----------------------------------------------------------------
  // Option card selection (step 1)
  // ----------------------------------------------------------------

  function bindOptionCards() {
    builder.addEventListener('click', function (e) {
      if (e.target.closest('.tooltip-trigger, .tooltip-content, .tooltip-wrapper')) {
        return;
      }

      var card = e.target.closest('.option-card[data-value]');
      if (!card || card.disabled || card.classList.contains('option-card--unavailable')) return;

      var group = card.closest('.option-cards[data-group]');
      if (!group) return;

      var groupName = group.dataset.group;
      var value = card.dataset.value;

      group.querySelectorAll('.option-card').forEach(function (c) {
        c.classList.remove('selected');
      });
      card.classList.add('selected');
      syncOptionGroupFade(group);

      if (groupName === 'style') {
        if (state.style !== value) {
          clearFinishSelection();
          clearSizeSelection();
          clearOrientationSelection();
        }
        state.style = value;
        updateFinishAvailability();
        if (state.step === 2) renderModuleSlots();
      } else if (groupName === 'finish') {
        if (state.finish !== value) {
          clearSizeSelection();
          clearOrientationSelection();
        }
        state.finish = value;
        updateFinishAvailability();
        sanitizeModuleFinishesInDrafts();
        if (state.step === 2) renderModuleSlots();
      } else if (groupName === 'size') {
        var newCount = parseInt(card.dataset.gangCount);
        var sizeLabelEl = card.querySelector('.option-card-subtitle')
          || card.querySelector('.option-card-label');
        // data-size-label = the full label; the subtitle can be just "Module" when the card's
        // big figure is the label's own number (Italian Grove "3 module").
        var sizeLabel = card.dataset.sizeLabel || (sizeLabelEl ? sizeLabelEl.textContent.trim() : value);
        if (state.size !== value) {
          clearOrientationSelection();
          state.size = value;
          state.sizeLabel = sizeLabel;
          state.gangCount = newCount;
          state.slots = {}; // reset slots when plate changes
          slotDrafts = {};
          expandedSlot = null;
          resetEngraving(); // stale position keys reference old gang count
        }
      } else if (groupName === 'orientation') {
        state.orientation = value;
      }

      // Full UI refresh so button state / price / preview catch the
      // new selection — cheaper than threading individual updates
      // through every option change.
      updateUI();
    });
  }

  // ----------------------------------------------------------------
  // Preview
  // ----------------------------------------------------------------

  function isVerticalPlatePreview() {
    return state.orientation === 'vertical';
  }

  // Full centre-to-centre span of a split gang for preview / engraving layout.
  // Pairable split toggles: widthMm is one half (e.g. 18mm) → span = width × 2.5.
  // Inline double-rocker: widthMm is the whole module (e.g. 45mm) → span = width.
  function splitGangSpanMm(ref, plateWidthMm, plateHeightMm) {
    var moduleW = Number(ref && ref.widthMm) || 0;
    var pitch = Number(ref && ref.engravingPitchMm) || 0;

    if (moduleW > 0) {
      return moduleUsesInlineDoubleEngraving(ref) ? moduleW : moduleW * 2.5;
    }
    if (pitch > 0) {
      return pitch;
    }
    var plateSpan = plateWidthMm > 0 ? plateWidthMm : plateHeightMm;
    return plateSpan > 0 ? plateSpan * 0.35 : 24;
  }

  // Overlay % at the centre of each module image — mirrors the split
  // flex container layout (halves at ±span/4 from the gang centre).
  function moduleOverlayCenterPercent(centreXMm, centreYMm, half, ref, plateWidthMm, plateHeightMm, extraOffsetXMm) {
    var slotLeftPct = 50 + (centreXMm / plateWidthMm * 100);
    var slotTopPct = 50 + (centreYMm / plateHeightMm) * 100;
    var vertical = isVerticalPlatePreview();

    if (half && ref) {
      var spanMm = splitGangSpanMm(ref, plateWidthMm, plateHeightMm);
      var halfOffsetPct = (spanMm / 4) / (vertical ? plateHeightMm : plateWidthMm) * 100;
      // Vertical preview rotates the wrapper 90deg CW, so flex-column
      // top/bottom maps to screen right/left — invert vs horizontal.
      var sign = half === 'a' ? -1 : 1;
      if (vertical) {
        sign = half === 'a' ? 1 : -1;
        return { leftPct: slotLeftPct, topPct: slotTopPct + sign * halfOffsetPct };
      }
      return { leftPct: slotLeftPct + sign * halfOffsetPct, topPct: slotTopPct };
    }

    if (extraOffsetXMm) {
      if (vertical) {
        return {
          leftPct: slotLeftPct,
          topPct: slotTopPct + (extraOffsetXMm / plateHeightMm * 100)
        };
      }
      return {
        leftPct: slotLeftPct + (extraOffsetXMm / plateWidthMm * 100),
        topPct: slotTopPct
      };
    }

    return { leftPct: slotLeftPct, topPct: slotTopPct };
  }

  // Map engraving baselines to overlay left/top % using the same overlay
  // coordinates as module images. Vertical preview rotates the wrapper
  // 90deg CW: overlay top → screen horizontal, overlay left → screen
  // vertical, so above/below on screen offsets overlay left.
  function engravingOverlayPosition(moduleLeftPct, moduleTopPct, aboveMm, belowMm, plateWidthMm, plateHeightMm, rows) {
    // aboveMm/belowMm are calibrated against a single-row, single-gang plate
    // (~80mm tall) — plateHeightMm is the WHOLE plate's height, which grows
    // with row count on multi-row plates (151mm for 2 rows, not a clean
    // 2x80, since rows share material). Using plateHeightMm/2 directly on a
    // multi-row plate roughly doubles the offset magnitude, pushing each
    // row's text past its own row-centre and into the next row. Dividing by
    // rows first recovers the single-row reference the offsets assume; a
    // single-row plate (rows=1, the common case) is unaffected.
    var singleRowHeightMm = plateHeightMm / (rows || 1);
    var plateCenterYmm = singleRowHeightMm / 2;
    var aboveOffsetMm = plateCenterYmm - aboveMm;
    var belowOffsetMm = belowMm - plateCenterYmm;

    if (!isVerticalPlatePreview()) {
      var moduleCenterYmm = (moduleTopPct / 100) * plateHeightMm;
      return {
        aboveLeft: moduleLeftPct,
        aboveTop: ((moduleCenterYmm - aboveOffsetMm) / plateHeightMm) * 100,
        belowLeft: moduleLeftPct,
        belowTop: ((moduleCenterYmm + belowOffsetMm) / plateHeightMm) * 100
      };
    }

    var moduleCenterXmm = (moduleLeftPct / 100) * plateWidthMm;
    return {
      aboveLeft: ((moduleCenterXmm - aboveOffsetMm) / plateWidthMm) * 100,
      aboveTop: moduleTopPct,
      belowLeft: ((moduleCenterXmm + belowOffsetMm) / plateWidthMm) * 100,
      belowTop: moduleTopPct
    };
  }

  function appendModuleOverlaySlot(parent, mod, centreXMm, centreYMm, plateWidthMm, plateHeightMm) {
    if (!mod || mod.isSkip) return;

    var leftPercent = plateWidthMm ? 50 + (centreXMm / plateWidthMm * 100) : 50;
    var topPercent = plateHeightMm ? 50 + (centreYMm / plateHeightMm * 100) : 50;

    var div = document.createElement('div');
    div.className = 'module-overlay-slot';
    div.style.left = leftPercent + '%';
    div.style.top = topPercent + '%';

    if (mod.widthMm && plateWidthMm) {
      div.style.width = (mod.widthMm / plateWidthMm * 100) + '%';
    }
    if (mod.isCutout) div.classList.add('module-overlay-slot--cutout');
    if (mod.image) {
      var img = document.createElement('img');
      img.src = mod.image;
      img.alt = mod.displayTitle || mod.title;
      div.appendChild(img);
    }
    parent.appendChild(div);
  }

  function splitHalfCenterOffsetMm(ref, plateWidthMm, plateHeightMm) {
    return splitGangSpanMm(ref, plateWidthMm, plateHeightMm) / 4;
  }

  // N independent overlay slots for a split/stacked gang position — same width
  // sizing as a single module (widthMm / plateWidth). Evenly spaces N equal parts
  // across the position's visual span: part i sits at span * ((i + 0.5) / n - 0.5)
  // from the gang centre (for n = 2 that is ±span/4, EU's original pairing).
  // Axis: EU pairs sit side by side and follow the plate preview's orientation; a
  // vertically stacked layout (US keystones, bespoke_layout.stack_direction =
  // vertical) runs along the other axis — XOR with the preview orientation.
  function appendSplitModuleOverlays(parent, slot, centreXMm, centreYMm, plateWidthMm, plateHeightMm) {
    var keys = halfKeysForSlot(slot);
    var mods = keys.map(function (k) { return slot[k]; });
    var ref = mods.filter(Boolean)[0];
    if (!ref) return;

    var spanMm = splitGangSpanMm(ref, plateWidthMm, plateHeightMm);
    var n = mods.length;
    var alongY = slotStacksVertically(slot) !== isVerticalPlatePreview();

    mods.forEach(function (mod, i) {
      var offsetMm = spanMm * ((i + 0.5) / n - 0.5);
      if (alongY) {
        appendModuleOverlaySlot(parent, mod, centreXMm, centreYMm + offsetMm, plateWidthMm, plateHeightMm);
      } else {
        appendModuleOverlaySlot(parent, mod, centreXMm + offsetMm, centreYMm, plateWidthMm, plateHeightMm);
      }
    });
  }

  function updatePreview() {
    var plateVariant = getPlateVariant();
    var plate = getPlate();

    if (!plateVariant || !plate || !plate.image) {
      emptyMsg.style.display = '';
      plateWrapper.classList.remove('visible');
      plateImage.removeAttribute('src');
      moduleOverlays.innerHTML = '';
      engravingOverlay.innerHTML = '';
      engravingOverlay.hidden = true;
      scheduleStickyUpdate();
      return;
    }

    emptyMsg.style.display = 'none';
    plateWrapper.classList.add('visible');
    plateWrapper.classList.toggle('preview-plate-wrapper--vertical', isVerticalPlatePreview());

    // Swap plate image only if it actually changed, so the onload
    // hook doesn't re-fire on every state change and thrash the
    // engraving scaling.
    if (plateImage.getAttribute('src') !== plate.image) {
      plateImage.onload = function () {
        // Height mm is derived from the image aspect ratio when the
        // metaobject omits plate_height_mm — re-layout modules once
        // natural dimensions are known (split vertical spacing).
        updatePreview();
      };
      plateImage.src = plate.image;
    }
    plateImage.alt = capitalise(state.style) + ' ' + getFinishLabel(state.finish) + ' plate';

    // Module overlays — laid out from real-world mm data on the plate
    // metaobject. Each slot is positioned absolutely at its computed
    // centre within the plate image, and sized from the module's mm
    // width relative to the plate's mm width. Split slots render two
    // half-width overlays side-by-side at the slot centre.
    moduleOverlays.innerHTML = '';

    var rows = plate.rows || 1;
    var cols = plate.cols || state.gangCount;
    var pitchX = plate.pitchX || 0;
    var pitchY = plate.pitchY || 0;
    var plateWidthMm = plate.widthMm;
    var plateHeightMm = resolvePlateHeightMm(plate, plateWidthMm);

    for (var i = 1; i <= state.gangCount; i++) {
      var slot = state.slots[i];
      var col = (i - 1) % cols;
      var row = Math.floor((i - 1) / cols);

      var centreXMm = (col - (cols - 1) / 2) * pitchX;
      var centreYMm = (row - (rows - 1) / 2) * pitchY;

      if (isSplit(slot)) {
        appendSplitModuleOverlays(moduleOverlays, slot, centreXMm, centreYMm, plateWidthMm, plateHeightMm);
      } else {
        appendModuleOverlaySlot(moduleOverlays, slot, centreXMm, centreYMm, plateWidthMm, plateHeightMm);
      }
    }

    // Engraving overlay rides on the same plate image, rendered from
    // mm-space offsets independently of module overlays. Kept in sync
    // with the plate + slots here so the preview updates when the
    // customer changes a module mid-flow. Mounted whenever we're on
    // Step 3 (even before any text is entered, so the input handler
    // has live spans to write into) OR on any other step while
    // engraving text exists (so Review / later previews show the
    // engraved text).
    var shouldMountOverlay = engravingAvailable()
      && (state.step === 3 || state.engraving.enabled);

    if (shouldMountOverlay) {
      renderEngravingOverlay();
      requestAnimationFrame(scaleEngravingOverlays);
    } else {
      engravingOverlay.innerHTML = '';
      engravingOverlay.hidden = true;
    }

    scheduleStickyUpdate();
  }

  // ----------------------------------------------------------------
  // Module slots — Step 2 (inline accordion)
  // ----------------------------------------------------------------

  function bindSlotsContainer() {
    if (!slotsContainer) return;
    slotsContainer.addEventListener('click', handleSlotsClick);
    // Show on hover and keyboard focus too (not just click/tap). mouseover/out
    // bubble, so they work via delegation; click is kept for touch devices.
    slotsContainer.addEventListener('mouseover', handleInfoPointerOver);
    slotsContainer.addEventListener('mouseout', handleInfoPointerOut);
    slotsContainer.addEventListener('focusin', handleInfoPointerOver);
    slotsContainer.addEventListener('focusout', handleInfoPointerOut);
  }

  function handleInfoPointerOver(e) {
    var btn = e.target.closest('[data-info-tooltip]');
    if (btn) showInfoTooltip(btn, btn.dataset.infoTooltip);
  }

  function handleInfoPointerOut(e) {
    var btn = e.target.closest('[data-info-tooltip]');
    if (!btn || activeTooltipAnchor !== btn) return;
    // Ignore moves between the button and its own children (e.g. the svg).
    if (e.relatedTarget && btn.contains(e.relatedTarget)) return;
    hideInfoTooltip();
  }

  function handleSlotsClick(e) {
    var infoBtn = e.target.closest('[data-info-tooltip]');
    if (infoBtn) {
      e.preventDefault();
      e.stopPropagation();
      showInfoTooltip(infoBtn, infoBtn.dataset.infoTooltip);
      return;
    }

    var expandBtn = e.target.closest('[data-slot-expand]');
    if (expandBtn) {
      var n = parseInt(expandBtn.dataset.slotExpand, 10);
      // Opening another position abandons a half-made change elsewhere: that position keeps
      // its committed module.
      Object.keys(slotDrafts).forEach(function (k) {
        var other = slotDrafts[k];
        if (Number(k) !== n && other && other._reconfiguring && other._edited) delete slotDrafts[k];
      });
      expandedSlot = n;
      if (expandedSlot) {
        var committed = state.slots[expandedSlot];
        ensureSlotDraft(expandedSlot, committed);
        if (committed && isSlotComplete(committed)) {
          slotDrafts[expandedSlot]._reconfiguring = true;
          slotDrafts[expandedSlot]._edited = false;
        }
      }
      if (nextBtn) nextBtn.disabled = !validateStep(state.step);
      // renderModuleSlots() pins scrollY across its innerHTML rebuild (BugHerd #211),
      // so the tap no longer jumps the page up; scrollPositionSlotIntoView() then only
      // ever eases DOWN to bring the newly opened options into view.
      renderModuleSlots();
      scrollPositionSlotIntoView(n);
      return;
    }

    // A pick inside a position that was already complete starts an edit: Next waits until it is
    // finished (the new pick then replaces the committed one) instead of moving on with the old
    // module while the half-made change is dropped (GPT review 2026-10-13).
    var editBtn = e.target.closest('[data-slot-category], [data-slot-layout-index], [data-slot-module-finish], [data-slot-switch-type], [data-slot-fit]');
    if (editBtn && !editBtn.disabled && !editBtn.classList.contains('module-finish-card--unavailable')) {
      markSlotEdited(parseInt(editBtn.dataset.slotNum, 10));
    }

    var catBtn = e.target.closest('[data-slot-category]');
    if (catBtn) {
      var slotNum = parseInt(catBtn.dataset.slotNum, 10);
      var draft = ensureSlotDraft(slotNum);
      draft.category = catBtn.dataset.slotCategory;
      draft.layoutIndex = null;
      draft.layout = null;
      draft.layoutMode = null;
      draft.moduleFinish = defaultModuleFinish(draft.category);
      draft.switchType = null;
      draft.fitMode = null;
      draft.halves = null;
      resetSplitHalves(draft);
      renderModuleSlots();
      scrollPositionSlotIntoView(slotNum);
      return;
    }

    var layoutBtn = e.target.closest('[data-slot-layout-index]');
    if (layoutBtn) {
      var sn = parseInt(layoutBtn.dataset.slotNum, 10);
      var d = ensureSlotDraft(sn);
      var idx = parseInt(layoutBtn.dataset.slotLayoutIndex, 10);
      var baseLayout = (data.layouts || [])[idx];
      var variantMode = layoutBtn.dataset.slotVariantMode
        || (baseLayout && baseLayout.slotsRequired > 1 ? 'double' : 'single');

      assignDraftLayoutForVariant(d, baseLayout, variantMode);
      d.fitMode = null;
      renderModuleSlots();
      scrollPositionSlotIntoView(sn);
      return;
    }

    var finishBtn = e.target.closest('[data-slot-module-finish]');
    if (finishBtn) {
      if (finishBtn.disabled || finishBtn.classList.contains('module-finish-card--unavailable')) return;
      var slotNumF = parseInt(finishBtn.dataset.slotNum, 10);
      var draftF = ensureSlotDraft(slotNumF);
      var finishVal = finishBtn.dataset.slotModuleFinish;
      var halfF = finishBtn.dataset.slotHalf;
      if (halfF) {
        var halfDraft = ensureHalfDraft(draftF, halfF);
        halfDraft.moduleFinish = finishVal;
        halfDraft.switchType = null;
        halfDraft.module = null;
      } else {
        draftF.moduleFinish = finishVal;
        draftF.switchType = null;
        draftF.module = null;
      }
      renderModuleSlots();
      if (!maybeAutoPickProduct(slotNumF, halfF || null)) scrollPositionSlotIntoView(slotNumF);
      return;
    }

    var typeBtn = e.target.closest('[data-slot-switch-type]');
    if (typeBtn) {
      var slotNumT = parseInt(typeBtn.dataset.slotNum, 10);
      var draftT = ensureSlotDraft(slotNumT);
      var halfT = typeBtn.dataset.slotHalf;
      if (halfT) {
        var halfPick = ensureHalfDraft(draftT, halfT);
        halfPick.switchType = typeBtn.dataset.slotSwitchType;
        halfPick.module = null;
      } else {
        draftT.switchType = typeBtn.dataset.slotSwitchType;
        draftT.module = null;
      }
      renderModuleSlots();
      if (!maybeAutoPickProduct(slotNumT, halfT || null)) scrollPositionSlotIntoView(slotNumT);
      return;
    }

    var fitBtn = e.target.closest('[data-slot-fit]');
    if (fitBtn) {
      var slotNumM = parseInt(fitBtn.dataset.slotNum, 10);
      var draftM = ensureSlotDraft(slotNumM);
      var halfM = fitBtn.dataset.slotHalf || null;
      var pickM = halfM ? ensureHalfDraft(draftM, halfM) : draftM;
      pickM.fitMode = fitBtn.dataset.slotFit;
      // One hole shape for this layout (toggle, dimmer, rocker, keystone): nothing left to
      // ask, so the cutout commits straight away. Several (socket): show the shape cards.
      if (pickM.fitMode === 'cutout') {
        var fitApertures = cutoutAperturesForLayout(draftM.layout);
        if (fitApertures.length === 1) {
          commitCutout(slotNumM, fitApertures[0], halfM);
          return;
        }
      }
      renderModuleSlots();
      scrollPositionSlotIntoView(slotNumM);
      return;
    }

    var cutoutBtn = e.target.closest('[data-slot-cutout]');
    if (cutoutBtn) {
      commitCutout(
        parseInt(cutoutBtn.dataset.slotNum, 10),
        cutoutBtn.dataset.slotCutout,
        cutoutBtn.dataset.slotHalf || null
      );
      return;
    }

    var skipBtn = e.target.closest('[data-slot-skip]');
    if (skipBtn) {
      commitSkip(parseInt(skipBtn.dataset.slotNum, 10));
      return;
    }

    var productBtn = e.target.closest('[data-slot-product-id]');
    if (productBtn) {
      commitProductPick(
        parseInt(productBtn.dataset.slotNum, 10),
        parseInt(productBtn.dataset.slotProductId, 10),
        productBtn.dataset.slotHalf || null
      );
      return;
    }

    var resetHalfBtn = e.target.closest('[data-slot-half-reset]');
    if (resetHalfBtn) {
      var slotNumR = parseInt(resetHalfBtn.dataset.slotNum, 10);
      var draftR = ensureSlotDraft(slotNumR);
      var halfR = resetHalfBtn.dataset.slotHalfReset;
      var pickR = ensureHalfDraft(draftR, halfR);
      pickR.fitMode = (pickR.module && pickR.module.isCutout) ? 'cutout' : 'module';
      pickR.module = null;
      pickR.switchType = null;
      // Changing half of a complete position is an edit: the committed position stays until
      // every part is picked again, so opening another position can still abandon it.
      if (draftR._reconfiguring) {
        draftR._edited = true;
      } else {
        state.slots[slotNumR] = null;
      }
      renderModuleSlots();
      updateUI();
      return;
    }
  }

  function markSlotEdited(slotNum) {
    var d = slotDrafts[slotNum];
    if (!d || !d._reconfiguring) return;
    d._edited = true;
    if (nextBtn) nextBtn.disabled = !validateStep(state.step);
  }

  // A change to a complete position that hasn't been finished (its draft is deleted on commit).
  function hasUnfinishedEdit() {
    return Object.keys(slotDrafts).some(function (k) {
      var d = slotDrafts[k];
      return !!(d && d._reconfiguring && d._edited);
    });
  }

  // A split position has 2 parts (EU side-by-side pair) or up to 3 (US keystone stack,
  // slot_capacity: 3). These two helpers are the single source of truth for "how many
  // parts does this split slot have": halfKeysForLayout for an in-progress draft (the
  // layout's slotsRequired is known), halfKeysForSlot for a committed slot (no layout
  // reference kept, so infer from whether a 'c' key was set at commit time — a 2-way
  // slot never has one).
  function halfKeysForLayout(layout) {
    var n = layout ? (Number(layout.slotCapacity) || Number(layout.slotsRequired) || 0) : 0;
    return n >= 3 ? ['a', 'b', 'c'] : ['a', 'b'];
  }

  function halfKeysForSlot(slot) {
    return (slot && Object.prototype.hasOwnProperty.call(slot, 'c')) ? ['a', 'b', 'c'] : ['a', 'b'];
  }

  // First occupied part of a split slot — all parts share a module type, so one part
  // can stand for the stack (engraving eligibility, thumbnails, layout lookup).
  function representativeSplitModule(slot) {
    var keys = halfKeysForSlot(slot);
    for (var i = 0; i < keys.length; i++) {
      if (slot[keys[i]]) return slot[keys[i]];
    }
    return null;
  }

  function slotLayout(slot) {
    if (!slot) return null;
    // Prefer the layout recorded at commit time — a product can sit in more than one
    // layout collection, so a product lookup alone could pick the wrong one.
    var meta = slot._pickMeta;
    if (meta && meta.layoutIndex != null && data.layouts && data.layouts[meta.layoutIndex]) {
      return data.layouts[meta.layoutIndex];
    }
    var rep = slot.split ? representativeSplitModule(slot) : slot;
    var found = rep && rep.id ? findLayoutForProduct(rep.id) : null;
    return found ? found.layout : null;
  }

  // True when the committed slot's layout stacks its parts vertically (US keystones).
  function slotStacksVertically(slot) {
    var l = slotLayout(slot);
    return !!(l && l.stackDirection === 'vertical');
  }

  function resetSplitHalves(draft) {
    var halves = {};
    halfKeysForLayout(draft.layout).forEach(function (k) {
      halves[k] = { moduleFinish: defaultModuleFinish(draft.category), switchType: null, module: null, fitMode: null };
    });
    draft.halves = halves;
  }

  function ensureHalfDraft(draft, half) {
    if (!draft.halves) resetSplitHalves(draft);
    return draft.halves[half];
  }

  function findLayoutForProduct(productId) {
    for (var i = 0; i < (data.layouts || []).length; i++) {
      var layout = data.layouts[i];
      if ((layout.products || []).some(function (p) { return p.id === productId; })) {
        return { layout: layout, layoutIndex: i };
      }
    }
    return null;
  }

  function captureHalfPickMeta(draft, half) {
    var pick = draftPickState(draft, half);
    return {
      moduleFinish: pick.moduleFinish || null,
      switchType: pick.switchType || null
    };
  }

  function captureSlotPickMeta(draft) {
    return {
      category: draft.category || null,
      layoutIndex: draft.layoutIndex,
      layoutMode: draft.layoutMode || null
    };
  }

  function attachHalfPickMeta(moduleObj, meta) {
    if (!moduleObj || !meta) return;
    moduleObj._pickMeta = meta;
  }

  function hydrateSlotDraftFromCommitted(draft, existingSlot) {
    if (!existingSlot || !isSlotComplete(existingSlot)) return;

    var slotMeta = existingSlot._pickMeta;
    var repModule = existingSlot.split ? (existingSlot.a || existingSlot.b) : existingSlot;
    var found = repModule && repModule.id ? findLayoutForProduct(repModule.id) : null;

    if (slotMeta && slotMeta.category) {
      draft.category = slotMeta.category;
    } else if (found) {
      draft.category = found.layout.categoryKey;
    }

    if (slotMeta && slotMeta.layoutIndex != null) {
      draft.layoutIndex = slotMeta.layoutIndex;
    } else if (found) {
      draft.layoutIndex = found.layoutIndex;
    }

    var baseLayout = draft.layoutIndex != null ? data.layouts[draft.layoutIndex] : (found ? found.layout : null);
    var layoutMode = (slotMeta && slotMeta.layoutMode) || (existingSlot.split ? 'double' : 'single');

    draft.layoutMode = layoutMode;
    if (baseLayout) {
      if (layoutMode === 'double' && isSplitLayout(baseLayout)) {
        draft.layout = Object.assign({}, baseLayout, { products: excludeDoubleWidthModules(baseLayout.products) });
      } else if (layoutMode === 'double') {
        draft.layout = baseLayout;
      } else {
        draft.layout = Object.assign({}, baseLayout, { slotsRequired: 1 });
      }
    }

    if (existingSlot.split) {
      resetSplitHalves(draft);
      halfKeysForSlot(existingSlot).forEach(function (k) {
        var part = existingSlot[k];
        if (!part || !draft.halves[k]) return;
        draft.halves[k].module = part;
        draft.halves[k].fitMode = part.isCutout ? 'cutout' : 'module';
        if (part._pickMeta) {
          draft.halves[k].moduleFinish = part._pickMeta.moduleFinish;
          draft.halves[k].switchType = part._pickMeta.switchType;
        }
      });
      return;
    }

    draft.halves = null;
    draft.fitMode = existingSlot.isCutout ? 'cutout' : 'module';
    if (existingSlot._pickMeta) {
      draft.moduleFinish = existingSlot._pickMeta.moduleFinish;
      draft.switchType = existingSlot._pickMeta.switchType;
    }
  }

  function ensureSlotDraft(slotNum, existingSlot) {
    if (!slotDrafts[slotNum]) {
      slotDrafts[slotNum] = {
        category: null,
        layoutIndex: null,
        layout: null,
        layoutMode: null,
        moduleFinish: defaultModuleFinish(null),
        switchType: null,
        halves: null
      };
    }
    if (existingSlot && isSlotComplete(existingSlot)) {
      hydrateSlotDraftFromCommitted(slotDrafts[slotNum], existingSlot);
    } else if (existingSlot && existingSlot.split && !slotDrafts[slotNum].halves) {
      var d = slotDrafts[slotNum];
      resetSplitHalves(d);
      halfKeysForSlot(existingSlot).forEach(function (k) {
        if (existingSlot[k] && d.halves[k]) d.halves[k].module = existingSlot[k];
      });
    }
    return slotDrafts[slotNum];
  }

  function isInsertCategory(categoryKey) {
    // Rocker left the insert set (Option 2): it now picks a metal finish like toggle,
    // and its black/white insert colour is chosen as the final product card instead of
    // a separate step. Socket/keystone still pick insert colour as their "finish" step.
    // 'outlet' is the US module_category for sockets.
    return categoryKey === 'socket' || categoryKey === 'outlet' || categoryKey === 'keystone';
  }

  // Insert categories (socket / keystone) derive their type list from the products
  // of the chosen insert colour, so the type list must wait until an insert colour
  // is picked — otherwise the type could be selected first, which reads as confusing.
  // Non-insert categories (toggle / dimmer / rocker) have no insert-colour step, so
  // their type list shows straight away.
  // A category with a static type list (toggle/rocker, EU dimmer) is ready immediately;
  // anything product-derived (socket/outlet/keystone, US dimmer) must wait for a finish.
  function switchTypesReady(categoryKey, moduleFinish) {
    var staticTypes = SWITCH_TYPES[categoryKey];
    if (staticTypes && staticTypes.length) return true;
    return !!moduleFinish;
  }

  function getInsertColours() {
    var colours = data.insertColours || [];
    return colours.length ? colours : DEFAULT_INSERT_COLOURS;
  }

  function getModuleFinishesForCategory(categoryKey) {
    if (isInsertCategory(categoryKey)) return getInsertColours();
    return (data.moduleFinishes || []).filter(function (f) {
      return f.value !== PAINTABLE_FINISH;
    });
  }

  function defaultModuleFinish(categoryKey) {
    if (isInsertCategory(categoryKey)) return null;
    if (state.finish && PRESELECT_MODULE_FINISHES.indexOf(state.finish) !== -1) {
      return state.finish;
    }
    return null;
  }

  function sanitizePickFinish(pick, categoryKey) {
    if (!pick || !pick.moduleFinish) return;
    var valid = getModuleFinishesForCategory(categoryKey).some(function (f) {
      return f.value === pick.moduleFinish;
    });
    if (!valid) {
      pick.moduleFinish = defaultModuleFinish(categoryKey);
      pick.module = null;
    }
  }

  function sanitizeModuleFinishesInDrafts() {
    Object.keys(slotDrafts).forEach(function (slotNum) {
      var draft = slotDrafts[slotNum];
      if (!draft.category) return;
      sanitizePickFinish(draft, draft.category);
      if (draft.halves) {
        Object.keys(draft.halves).forEach(function (k) {
          sanitizePickFinish(draft.halves[k], draft.category);
        });
      }
    });
  }

  function isSlotComplete(slot) {
    if (!slot) return false;
    if (slot.split) return halfKeysForSlot(slot).every(function (k) { return !!slot[k]; });
    return true;
  }

  // Only layouts that fit a position on the selected plate (Italian Grove 3-module offers single
  // toggles and keystones only). A pairable layout counts if its single mode fits; its double mode
  // is checked separately in resolveVariantPair.
  function getLayoutsForCategory(categoryKey) {
    return (data.layouts || []).filter(function (l) {
      if (l.categoryKey !== categoryKey) return false;
      var mode = (Number(l.slotsRequired) > 1 && !l.pairable) ? 'double' : 'single';
      return layoutFitsPosition(l, mode);
    });
  }

  function finishStepLabel(categoryKey) {
    if (isInsertCategory(categoryKey)) return I18N.insertColour || 'INSERT COLOUR';
    return fillTokens(I18N.finishHeading || '__CATEGORY__ FINISH', { '__CATEGORY__': (categoryKey ? categoryLabel(categoryKey) : 'module').toUpperCase() });
  }

  function resolveVariantPair(categoryKey) {
    var layouts = getLayoutsForCategory(categoryKey);
    var singles = layouts.filter(function (l) { return l.slotsRequired <= 1; });
    var doubles = layouts.filter(function (l) { return l.slotsRequired > 1; });
    var single = singles[0] || null;
    var double = doubles[0] || null;

    // One pairable layout can back both options (same collection, single vs split pick).
    // keystone included so a 2x keystone works like a double toggle (BugHerd #450) —
    // inert until the keystone layout is marked pairable in Admin.
    if (!single && double && (categoryKey === 'toggle' || categoryKey === 'rocker' || categoryKey === 'keystone')) {
      single = double;
    }
    if (double && !layoutFitsPosition(double, 'double')) double = null;

    return { single: single, double: double };
  }

  function categoryNeedsVariantStep(categoryKey) {
    var pair = resolveVariantPair(categoryKey);
    return !!(pair.single && pair.double);
  }

  function isVariantSelected(draft, layoutIndex, variantMode) {
    if (draft.layoutIndex !== layoutIndex || !draft.layout) return false;
    if (draft.layoutMode !== variantMode) return false;
    if (variantMode === 'double') {
      if (isSplitLayout(draft.layout)) return isSplitLayoutForDraft(draft);
      return Number(draft.layout.slotsRequired) > 1;
    }
    if (isSplitLayout(draft.layout)) return !isSplitLayoutForDraft(draft);
    return Number(draft.layout.slotsRequired) <= 1;
  }

  function assignDraftLayoutForVariant(draft, baseLayout, variantMode) {
    var idx = data.layouts.indexOf(baseLayout);
    draft.layoutIndex = idx;
    draft.layoutMode = variantMode;

    if (variantMode === 'single') {
      draft.layout = Object.assign({}, baseLayout, { slotsRequired: 1 });
      draft.halves = null;
      if (!draft.moduleFinish) draft.moduleFinish = defaultModuleFinish(draft.category);
      draft.switchType = null;
      return;
    }

    if (isSplitLayout(baseLayout)) {
      draft.layout = Object.assign({}, baseLayout, { products: excludeDoubleWidthModules(baseLayout.products) });
      resetSplitHalves(draft);
      draft.moduleFinish = null;
      draft.switchType = null;
      return;
    }

    draft.layout = baseLayout;
    draft.halves = null;
    if (!draft.moduleFinish) draft.moduleFinish = defaultModuleFinish(draft.category);
    draft.switchType = null;
  }

  function productMatchesInsertColour(product, colour) {
    if (!colour) return true;
    // Prefer the locale-stable metafield (bespoke.insert_colour); fall back to the
    // title/handle heuristic when it isn't populated yet, plus the English title/handle on
    // translated storefronts (englishMatchText).
    if (product.insertColour) return product.insertColour === colour;
    var hay = (product.title + ' ' + (product.handle || '') + ' ' + englishText(product)).toLowerCase();
    var c = colour.toLowerCase();
    if (c === 'white') return /\bwhite\b/.test(hay);
    if (c === 'black') return /\bblack\b/.test(hay);
    return hay.indexOf(c) !== -1;
  }

  function productMatchesModuleFinish(product, finish, categoryKey) {
    if (isInsertCategory(categoryKey)) return productMatchesInsertColour(product, finish);
    return productMatchesFinish(product, finish);
  }

  function productMatchesFinish(product, finish) {
    if (!finish) return true;
    // Prefer the locale-stable metafield (bespoke.finish); fall back to the
    // title/tags/handle heuristic when it isn't populated yet.
    if (product.finish) return product.finish === finish;
    var f = finish.toLowerCase().replace(/-/g, ' ');
    var title = ((product.title || '') + ' ' + englishText(product)).toLowerCase();
    var tags = (product.tags || '').toLowerCase();
    var handle = (product.handle || '').toLowerCase();
    return title.indexOf(f) !== -1
      || tags.indexOf(finish) !== -1
      || handle.indexOf(finish.replace(/\s+/g, '-')) !== -1;
  }

  function productMatchesSwitchType(product, typeValue, categoryKey, layout, moduleFinish) {
    if (!typeValue) return true;
    var types = getSwitchTypes(categoryKey, layout, moduleFinish);
    var typeDef = types.find(function (t) { return t.value === typeValue; });
    if (!typeDef) return true;
    // Prefer the locale-stable metafield (bespoke.switch_type); fall back to the
    // title/handle heuristic (also covers socket/keystone, which have no metafield),
    // plus the English title/handle on translated storefronts (englishMatchText).
    if (product.switchType) return product.switchType === typeValue;
    var hay = (product.title + ' ' + (product.handle || '') + ' ' + englishText(product)).toLowerCase();
    return hay.indexOf(typeDef.filter) !== -1;
  }

  function productMatchesPlateFinishForCategory(product, categoryKey) {
    // Superseded by rocker Option 2: rocker now selects its metal finish like toggle
    // (filtered via the normal moduleFinish path), so no category-specific plate-finish
    // filter is needed. Always-true; retained so call sites don't need touching.
    return true;
  }

  function draftPickState(draft, half) {
    if (half && draft.halves) return draft.halves[half];
    return draft;
  }

  function filteredProductsForDraft(slotNum, half) {
    var draft = ensureSlotDraft(slotNum);
    if (!draft.layout) return [];
    var pick = draftPickState(draft, half);
    return (draft.layout.products || []).filter(function (p) {
      return productMatchesModuleFinish(p, pick.moduleFinish, draft.category)
        && productMatchesPlateFinishForCategory(p, draft.category)
        && productMatchesSwitchType(p, pick.switchType, draft.category, draft.layout, pick.moduleFinish);
    });
  }

  // Returns true if it auto-committed a product (commitProductPick already scrolls,
  // so callers must NOT also call scrollPositionSlotIntoView — that double-scroll was
  // part of the step-2 "jumping around").
  function maybeAutoPickProduct(slotNum, half) {
    var draft = ensureSlotDraft(slotNum);
    if (!draft.layout) return false;
    // BugHerd #189 — auto-commit the sole remaining product for split halves too.
    // Each half has already chosen its own finish + switch type before the product
    // step (so the "different switch types per half" case is preserved); once only
    // one product matches there's no real choice and the prompt is redundant.
    var pick = draftPickState(draft, half);
    if (!pick.moduleFinish) return false;
    var types = getSwitchTypes(draft.category, draft.layout, pick.moduleFinish);
    if (types.length > 0 && !pick.switchType) return false;

    var products = filteredProductsForDraft(slotNum, half);
    if (products.length === 1) {
      commitProductPick(slotNum, products[0].id, half);
      return true;
    }
    return false;
  }

  // Plate preview overlay — line/cutout from product metafield.
  function resolveModuleImage(product, layout) {
    return product.builderImage || layout.image || null;
  }

  // Layout / category thumbnails (category, single/double, "With a module" cards): the layout's
  // collection image, else the module_category block's Thumbnail, else layout.image. .com
  // layouts have no collection (modules are fetched by tag), and layout.image is the line
  // drawing the plate preview falls back to, so the Thumbnail is what gives these cards a photo.
  function categoryThumbnail(categoryKey) {
    var cat = (data.moduleCategories || []).find(function (c) { return c.value === categoryKey; });
    return (cat && cat.image) || null;
  }

  function resolveLayoutPanelImage(layout) {
    if (!layout) return null;
    return layout.collectionImage || categoryThumbnail(layout.categoryKey || layout.category) || layout.image || null;
  }

  function resolveCategoryImage(cat) {
    if (!cat) return null;
    var layouts = getLayoutsForCategory(cat.value);
    for (var i = 0; i < layouts.length; i++) {
      if (layouts[i].collectionImage) return layouts[i].collectionImage;
    }
    if (cat.image) return cat.image;
    for (var j = 0; j < layouts.length; j++) {
      if (layouts[j].image) return layouts[j].image;
    }
    return null;
  }

  function resolveSwitchTypeImage(typeDef, layout, moduleFinish, categoryKey) {
    if (!typeDef || !layout) return null;
    var products = (layout.products || []).filter(function (p) {
      return productMatchesModuleFinish(p, moduleFinish, categoryKey)
        && productMatchesSwitchType(p, typeDef.value, categoryKey, layout, moduleFinish);
    });
    if (products.length && products[0].featuredImage) return products[0].featuredImage;
    return resolveLayoutPanelImage(layout);
  }

  // Step 2 summary + review thumbs for a chosen product.
  function resolvePanelProductImage(product) {
    return product.featuredImage || null;
  }

  function resolveProductPickImage(product) {
    return product.featuredImage || null;
  }

  // Resolve engraving line widths from layout metaobject fields.
  // mode: 'single' | 'half' (one line per split half) | 'inline-double' (two lines, one module)
  function resolveEngravingWidths(layout, mode) {
    if (!layout) return [];

    var list = layout.engravingMaxWidthsMm || [];
    var single = Number(layout.engravingMaxWidthSingleMm) || 0;
    var half = Number(layout.engravingMaxWidthHalfMm) || 0;

    if (mode === 'half') {
      if (half > 0) return [half];
      if (list.length >= 2) return [list[1] > 0 ? list[1] : list[0]];
      if (list.length === 1) return [list[0]];
      return [];
    }

    if (mode === 'single') {
      var full = single > 0 ? single : (list.length >= 1 ? list[0] : 0);
      // Text wider than the gap to the next position would run into its neighbour's: use the
      // half width instead (Italian Grove 3-module: 22.5mm pitch → 21.8, Michael 2026-10-02).
      var halfW = half > 0 ? half : (list.length >= 2 ? list[1] : 0);
      if (full > positionWidthMm() && halfW > 0) return [halfW];
      return full > 0 ? [full] : [];
    }

    if (mode === 'inline-double') {
      if (half > 0) return [half, half];
      if (list.length >= 2) return [list[0], list[1]];
      if (list.length === 1) return [list[0], list[0]];
      return [];
    }

    return list;
  }

  function layoutUsesInlineSplitEngraving(layout) {
    if (!layout || layout.pairable) return false;
    // Inline split engraving is only for non-pairable layouts that
    // physically contain two modules in one slot (e.g. double rocker).
    if (!(Number(layout.slotsRequired) > 1)) return false;
    return resolveEngravingWidths(layout, 'inline-double').length >= 2;
  }

  function slotUsesInlineSplitEngraving(slot) {
    if (!slot || slot.split) return false;
    if (moduleUsesInlineDoubleEngraving(slot)) return true;
    var layout = findLayoutWithEngravingWidths(slot);
    if (layout) return layoutUsesInlineSplitEngraving(layout);
    return false;
  }

  function engravingModeForCommit(draft, product) {
    if (!draft || !draft.layout) return 'single';
    // A vertically stacked position gets ONE whole-position engraving, so its parts carry
    // single-mode widths; side-by-side pairs engrave per half.
    if (isSplitLayoutForDraft(draft)) return draft.layout.stackDirection === 'vertical' ? 'single' : 'half';
    if (productUsesInlineDoubleEngraving(product)) return 'inline-double';
    if (layoutUsesInlineSplitEngraving(draft.layout)) return 'inline-double';
    return 'single';
  }

  function buildModuleObj(layout, product, engravingMode) {
    var previewImage = resolveModuleImage(product, layout);
    var panelImage = resolvePanelProductImage(product);
    var mode = engravingMode || 'single';
    var widths = resolveEngravingWidths(layout, mode);
    return {
      id: product.id,
      sku: product.sku || '',
      title: product.title,
      price: product.price,
      aperture: product.aperture || '',
      image: previewImage,
      productImage: panelImage,
      featuredImage: product.featuredImage || null,
      widthMm: layout.widthMm,
      engravingMaxWidthsMm: widths,
      engravingPitchMm: layout.engravingPitchMm || 0,
      engravingMode: mode,
      inlineDoubleEngraving: productUsesInlineDoubleEngraving(product),
      inlineSplitEngraving: mode === 'inline-double'
    };
  }

  function buildSlotSummary(slot) {
    if (!slot) return '';
    if (slot.split) {
      var parts = halfKeysForSlot(slot)
        .map(function (k) { return slot[k]; })
        .filter(Boolean)
        .map(function (mod) { return mod.displayTitle || mod.title; });
      return parts.join(' + ');
    }
    return slot.displayTitle || slot.title || '';
  }

  function buildDisplayTitle(draft, product, half) {
    var pick = draftPickState(draft, half);
    var typeLabel = '';
    if (pick.switchType) {
      var types = getSwitchTypes(draft.category, draft.layout, pick.moduleFinish);
      var t = types.find(function (x) { return x.value === pick.switchType; });
      if (t) typeLabel = t.label + ' ';
    }
    var catLabel = categoryLabel(draft.category);
    var finishLabel = getFinishLabel(pick.moduleFinish) || '';
    // BugHerd #193 — insert categories (socket/keystone) use an insert colour the
    // customer already picked, so don't repeat it in the module name (the Figma review
    // shows e.g. "Schuko Type F Socket", no suffix). Non-insert modules — incl. rocker
    // after Option 2 — keep their metal finish ("... - Bronze"). The committed variant
    // still encodes the insert colour, so this is display-only — fulfilment is unaffected.
    if (isInsertCategory(draft.category)) finishLabel = '';
    if (typeLabel || catLabel) {
      return (typeLabel + catLabel + (catLabel ? ' ' + (I18N.switchWord || 'Switch') : '') + (finishLabel ? ' - ' + finishLabel : '')).trim();
    }
    return product.title;
  }

  // ----------------------------------------------------------------
  // Cutout only / leave blank (2026-09-25)
  // ----------------------------------------------------------------
  // Two per-position choices that buy no module:
  //  - CUTOUT: the hole is cut, nothing fitted. A synthetic slot object (no product
  //    id, price 0) built from the chosen layout, so preview / engraving / the
  //    stock-plate matcher treat it like a module with that aperture.
  //  - SKIP ("leave blank"): the position is not cut at all. Whole positions only —
  //    a split (double) position can't have one half left blank. aperture '' makes
  //    buildConfigSignature return null, so a skipped config is always cut bespoke
  //    (no stock plate has an empty position).
  // Neither adds a cart line; both still write their `Bespoke | Position N` property
  // (English, the workshop reads it) and an entry in the hidden `_bespoke_spec`.
  // Plan: corston-command-centre briefings/bespoke-cutout-and-skip-both-builds.md.

  // English shape names: the fallback cart value for an aperture with no NetSuite template
  // (cutoutTemplateName below) and the untranslated card labels.
  var CUTOUT_APERTURE_LABELS_EN = {
    toggle: 'Round',
    circle: 'Round socket',
    square: 'Square',
    keystone: 'Keystone',
    outlet: 'Outlet'
  };
  // The visible `Bespoke | Position N` value for a position with no module is the matching entry
  // of NetSuite's "Bespoke templates" custom list, so the ERP reads it without a mapping (Oskar /
  // Michael 2026-10-05). Positions with a module still carry the module SKU. One entry per part:
  // each half of a split position gets its own single template ("EU 1x keystone" on 3a).
  // Keyed by aperture; the US holes have their own templates. The hidden _bespoke_spec keeps
  // the aperture + category (App-Hub's render reads that).
  var SKIP_CART_VALUE = 'Blank';
  var CUTOUT_TEMPLATE_NAMES = {
    eu: {
      toggle: 'EU 1x toggle',     // toggle + dimmer
      square: 'EU 45mm',          // rocker + square socket
      circle: 'EU circle',        // round socket
      keystone: 'EU 1x keystone'
    },
    us: {
      toggle: 'US Toggle',        // toggle + dimmer
      square: 'US Outlet',        // rocker: same Decora opening as the outlets
      outlet: 'US Outlet',
      keystone: 'US x1 Keystone'
    }
  };

  function cutoutTemplateName(aperture) {
    var names = CUTOUT_TEMPLATE_NAMES[REGION] || CUTOUT_TEMPLATE_NAMES.eu;
    return names[aperture]
      || ('Cutout – ' + (CUTOUT_APERTURE_LABELS_EN[aperture] || capitalise(aperture)));
  }

  function isSyntheticModule(mod) {
    return !!(mod && (mod.isCutout || mod.isSkip));
  }

  function isSkipSlot(slot) {
    return !!(slot && slot.isSkip);
  }

  // Hole shapes per category when a layout's products don't say (no products loaded, or
  // none carry custom.aperture) — the cutout must not depend on module data being there.
  var DEFAULT_CUTOUT_APERTURES = {
    toggle: ['toggle'],
    dimmer: ['toggle'],
    rocker: ['square'],
    socket: ['circle', 'square'],
    outlet: ['outlet'],
    keystone: ['keystone']
  };

  // Distinct apertures among the layout's products, in data order — a socket layout
  // can hold both round and square sockets, so it offers both cutouts. Falls back to the
  // category default.
  function cutoutAperturesForLayout(layout) {
    var seen = [];
    ((layout && layout.products) || []).forEach(function (p) {
      var ap = (p.aperture || '').trim();
      if (ap && seen.indexOf(ap) === -1) seen.push(ap);
    });
    if (!seen.length && layout) {
      seen = (DEFAULT_CUTOUT_APERTURES[layout.categoryKey] || []).slice();
    }
    return seen;
  }

  function cutoutApertureLabel(aperture) {
    var labels = I18N.cutoutApertures || {};
    return labels[aperture] || CUTOUT_APERTURE_LABELS_EN[aperture] || capitalise(aperture);
  }

  // Outline drawings supplied as theme assets, emitted from Liquid: per category first
  // (data.cutoutImagesByCategory, US only: its holes differ under the same aperture keys),
  // then per aperture (data.cutoutImages). Anything else gets a plain SVG outline so the
  // preview never shows a gap.
  function cutoutImageFor(aperture, categoryKey) {
    var byCategory = data.cutoutImagesByCategory || {};
    if (categoryKey && byCategory[categoryKey]) return byCategory[categoryKey];
    var images = data.cutoutImages || {};
    if (images[aperture]) return images[aperture];
    var shape;
    if (aperture === 'toggle' || aperture === 'circle') {
      shape = '<circle cx="50" cy="50" r="48"/>';
    } else if (aperture === 'keystone') {
      shape = '<rect x="12" y="2" width="76" height="96" rx="3"/>';
    } else if (aperture === 'outlet') {
      shape = '<rect x="24" y="2" width="52" height="96" rx="6"/>';
    } else {
      shape = '<rect x="2" y="2" width="96" height="96"/>';
    }
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="none" stroke="#333" stroke-width="1.5">' + shape + '</svg>';
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
  }

  function buildCutoutObj(draft, aperture) {
    var layout = draft.layout;
    var mode = engravingModeForCommit(draft, null);
    var widths = resolveEngravingWidths(layout, mode);
    var image = cutoutImageFor(aperture, draft.category);
    return {
      id: null,
      isCutout: true,
      sku: '',
      title: cutoutTemplateName(aperture),
      displayTitle: fillTokens(I18N.cutoutTitle || 'Cutout only – __SHAPE__', { '__SHAPE__': cutoutApertureLabel(aperture) }),
      price: 0,
      aperture: aperture,
      categoryKey: draft.category || null,
      // Cut for a double-width layout (non-pairable, 2 sub-slots: double rocker / Bipasso).
      doubleWidthLayout: !isSplitLayout(layout) && Number(layout.slotsRequired) > 1,
      image: image,
      productImage: image,
      featuredImage: null,
      widthMm: layout.widthMm,
      engravingMaxWidthsMm: widths,
      engravingPitchMm: layout.engravingPitchMm || 0,
      engravingMode: mode,
      inlineDoubleEngraving: false,
      inlineSplitEngraving: mode === 'inline-double'
    };
  }

  function buildSkipObj() {
    return {
      id: null,
      isSkip: true,
      sku: '',
      title: SKIP_CART_VALUE,
      displayTitle: I18N.notCut || 'Left blank – not cut',
      price: 0,
      aperture: '',
      image: null,
      productImage: null,
      featuredImage: null,
      widthMm: 0,
      engravingMaxWidthsMm: [],
      engravingPitchMm: 0,
      engravingMode: 'single',
      _pickMeta: { category: null, layoutIndex: null, layoutMode: null, moduleFinish: null, switchType: null }
    };
  }

  // "Leave blank" is offered only where it leaves at least one other position cut:
  // never on a 1-gang plate, and not when every other position is already blank.
  function canSkipPosition(slotNum) {
    if (!state.gangCount || state.gangCount < 2) return false;
    for (var i = 1; i <= state.gangCount; i++) {
      if (i === slotNum) continue;
      if (!isSkipSlot(state.slots[i])) return true;
    }
    return false;
  }

  function hasCutPosition() {
    for (var i = 1; i <= (state.gangCount || 0); i++) {
      if (state.slots[i] && !isSkipSlot(state.slots[i])) return true;
    }
    return false;
  }

  function commitCutout(slotNum, aperture, half) {
    var draft = ensureSlotDraft(slotNum);
    if (!draft.layout) return;
    if (cutoutAperturesForLayout(draft.layout).indexOf(aperture) === -1) return;
    commitModuleObj(slotNum, draft, buildCutoutObj(draft, aperture), half);
  }

  function commitSkip(slotNum) {
    if (!canSkipPosition(slotNum)) return;
    state.slots[slotNum] = buildSkipObj();
    delete slotDrafts[slotNum];
    resetEngraving();
    expandedSlot = firstIncompleteSlot();
    renderModuleSlots();
    updateUI();
    scrollPositionSlotIntoView(expandedSlot != null ? expandedSlot : slotNum);
  }

  // Module or cutout (Michael 2026-10-01). Once the layout is known, each position (or each
  // half of a split one) first asks whether a module is fitted: 'module' opens the finish /
  // switch type / product grids, 'cutout' commits the hole (one shape) or shows the shape
  // cards (several, e.g. a socket's round or square). A layout with no cutout shape skips
  // the question. pick = the draft itself, or the half's draft on a split position.
  function fitModeFor(draft, pick) {
    if (!cutoutAperturesForLayout(draft.layout).length) return 'module';
    return (pick && pick.fitMode) || null;
  }

  function renderFitChoice(slotNum, draft, half) {
    var apertures = cutoutAperturesForLayout(draft.layout);
    if (!apertures.length) return '';
    var pick = half ? ensureHalfDraft(draft, half) : draft;
    var halfAttr = half ? ' data-slot-half="' + half + '"' : '';
    var category = (data.moduleCategories || []).find(function (c) { return c.value === draft.category; });
    var moduleImage = category ? resolveCategoryImage(category) : null;
    var options = [
      { value: 'module', label: I18N.fitModule || 'With a module', image: moduleImage },
      { value: 'cutout', label: I18N.fitCutout || 'Cutout only (no module)', image: cutoutImageFor(apertures[0], draft.category) }
    ];
    var cards = options.map(function (o) {
      var selected = pick.fitMode === o.value ? ' selected' : '';
      return '<button type="button" class="module-option-card module-option-card--fit font-type-5' + selected + '"'
        + ' data-slot-num="' + slotNum + '"'
        + halfAttr
        + ' data-slot-fit="' + o.value + '">'
        + (o.image
            ? '<img src="' + o.image + '" alt="" class="module-option-thumb module-option-thumb--cutout" width="50" height="50">'
            : '<span class="module-option-thumb module-option-thumb--empty" aria-hidden="true"></span>')
        + '<span>' + escapeHtml(o.label) + '</span>'
        + '</button>';
    }).join('');
    return '<div class="module-subsection module-subsection--fit">'
      + '<h5 class="module-subsection-title font-type-3">' + (I18N.fitHeading || 'MODULE OR CUTOUT ONLY') + '</h5>'
      + '<div class="module-option-grid' + (pick.fitMode ? ' module-option-grid--has-selection' : '') + '">' + cards + '</div>'
      + '</div>';
  }

  function renderCutoutGrid(slotNum, draft, half) {
    var apertures = cutoutAperturesForLayout(draft.layout);
    // One shape: "Cutout only" in renderFitChoice commits it, so there is nothing to pick.
    if (apertures.length < 2) return '';
    var halfAttr = half ? ' data-slot-half="' + half + '"' : '';
    var cards = apertures.map(function (ap) {
      return '<button type="button" class="module-option-card module-option-card--cutout font-type-5"'
        + ' data-slot-num="' + slotNum + '"'
        + halfAttr
        + ' data-slot-cutout="' + escapeAttr(ap) + '">'
        + '<img src="' + cutoutImageFor(ap, draft.category) + '" alt="" class="module-option-thumb module-option-thumb--cutout" width="50" height="50">'
        + '<span>' + escapeHtml(cutoutApertureLabel(ap)) + '</span>'
        + '</button>';
    }).join('');
    return '<div class="module-subsection module-subsection--cutout">'
      + '<h5 class="module-subsection-title font-type-3">' + (I18N.cutoutShapeHeading || 'CUTOUT SHAPE') + '</h5>'
      + '<p class="module-subsection-hint font-type-5">' + (I18N.cutoutHint || 'We cut the hole for this position; no module is included.') + '</p>'
      + '<div class="module-option-grid">' + cards + '</div>'
      + '</div>';
  }

  // Hidden, versioned machine spec of every physical position, for App-Hub and the
  // ERP (the visible `Bespoke | Position N` values stay human-readable). Compact on
  // purpose — a line-item property value must stay short (Shopify caps some property
  // surfaces at 255 chars), so no JSON:
  //   v1|<pos>:m:<sku>|<pos>:c:<aperture>:<category>[:i]|<pos>:s
  // e.g. v1|1:m:31432|2:c:circle:socket|3:s   (<pos> = 1, 2a, 3c …; ':' / '|' never occur
  // in SKUs, apertures or category keys). The trailing `:i` marks a cutout cut for a
  // double-width (inline a/b engraved) layout — a category can have both a single and
  // a double-width layout, and they differ in width and engraving.
  function bespokeSpecEntry(mod) {
    if (!mod) return null;
    if (mod.isSkip) return 's';
    if (mod.isCutout) {
      return 'c:' + mod.aperture + ':' + (mod.categoryKey || (mod._pickMeta && mod._pickMeta.category) || '')
        + (mod.doubleWidthLayout ? ':i' : '');
    }
    return 'm:' + (mod.sku || '').trim();
  }

  function buildBespokeSpec() {
    var parts = ['v1'];
    for (var i = 1; i <= state.gangCount; i++) {
      var slot = state.slots[i];
      if (!slot) continue;
      if (slot.split) {
        halfKeysForSlot(slot).forEach(function (k) {
          var e = bespokeSpecEntry(slot[k]);
          if (e) parts.push(String(i) + k + ':' + e);
        });
      } else {
        var entry = bespokeSpecEntry(slot);
        if (entry) parts.push(String(i) + ':' + entry);
      }
    }
    return parts.join('|');
  }

  function commitProductPick(slotNum, productId, half) {
    var draft = ensureSlotDraft(slotNum);
    var layout = draft.layout;
    if (!layout) return;

    var product = (layout.products || []).find(function (p) { return p.id === productId; });
    if (!product) return;

    var moduleObj = buildModuleObj(layout, product, engravingModeForCommit(draft, product));
    moduleObj.displayTitle = buildDisplayTitle(draft, product, half);
    commitModuleObj(slotNum, draft, moduleObj, half);
  }

  // Shared commit tail for a real module pick and a cutout: split drafts fill one
  // part and commit the position once every part is set; otherwise commit directly.
  function commitModuleObj(slotNum, draft, moduleObj, half) {
    var layout = draft.layout;
    if (isSplitLayoutForDraft(draft)) {
      if (!half) return;
      attachHalfPickMeta(moduleObj, captureHalfPickMeta(draft, half));
      var h = ensureHalfDraft(draft, half);
      h.module = moduleObj;
      var requiredKeys = halfKeysForLayout(layout);
      var allPartsFilled = requiredKeys.every(function (k) {
        return draft.halves[k] && draft.halves[k].module;
      });
      if (allPartsFilled) {
        var committedSlot = { split: true, _pickMeta: captureSlotPickMeta(draft) };
        requiredKeys.forEach(function (k) { committedSlot[k] = draft.halves[k].module; });
        state.slots[slotNum] = committedSlot;
        delete slotDrafts[slotNum];
        resetEngraving();
        expandedSlot = firstIncompleteSlot();
        renderModuleSlots();
        updateUI();
        scrollPositionSlotIntoView(expandedSlot != null ? expandedSlot : slotNum);
      } else {
        renderModuleSlots();
      }
      return;
    }

    attachHalfPickMeta(moduleObj, Object.assign(
      captureSlotPickMeta(draft),
      captureHalfPickMeta(draft, null)
    ));
    state.slots[slotNum] = moduleObj;
    delete slotDrafts[slotNum];
    resetEngraving();
    expandedSlot = firstIncompleteSlot();
    renderModuleSlots();
    updateUI();
    scrollPositionSlotIntoView(expandedSlot != null ? expandedSlot : slotNum);
  }

  function renderModuleSlots() {
    if (!slotsContainer) return;
    if (renderModulesStatus()) return;
    // BugHerd #211 — every step-2 interaction (pick a category/layout/switch/
    // finish, expand, commit) re-renders by wiping slotsContainer.innerHTML, which
    // collapses the document height for one synchronous beat and lets the browser
    // clamp scrollY upward — the builder "jumps around" on each pick (step 1 doesn't
    // rebuild like this, so it's steady). Pin the scroll position across the rebuild;
    // it's the same synchronous task, so the collapsed frame never paints. Callers
    // that intentionally move the viewport (goToStep → scrollToBuilder, and
    // scrollPositionSlotIntoView) run after this returns, so they still win.
    var prevScrollY = window.scrollY;
    slotsContainer.innerHTML = '';

    for (var i = 1; i <= state.gangCount; i++) {
      var slot = state.slots[i];
      var isExpanded = expandedSlot === i;
      var isComplete = isSlotComplete(slot);

      var section = document.createElement('section');
      section.className = 'position-slot'
        + (isExpanded ? ' position-slot--expanded' : '')
        + (isComplete ? ' position-slot--complete' : '');
      section.dataset.slotNum = String(i);

      section.innerHTML = renderPositionHeader(i)
        + (isExpanded ? renderPositionExpanded(i) : renderPositionCollapsed(i, slot, isComplete));

      slotsContainer.appendChild(section);
    }

    updateLongListScrollFades();
    window.scrollTo({ top: prevScrollY });
  }

  function ordinalWord(n) {
    var words = (I18N.ordinals && I18N.ordinals.length) ? I18N.ordinals : ['', 'ONE', 'TWO', 'THREE', 'FOUR', 'FIVE', 'SIX', 'SEVEN', 'EIGHT'];
    return words[n] || String(n);
  }

  function renderPositionHeader(slotNum) {
    var label = fillTokens(I18N.positionHeading || 'Position __ORDINAL__', { '__ORDINAL__': ordinalWord(slotNum) });
    return '<div class="position-slot-header">'
      + '<h4 class="position-slot-title font-type-3">' + label + '</h4>'
      + '</div>';
  }

  function renderPositionCollapsed(slotNum, slot, isComplete) {
    if (isComplete) {
      var mod = isSplit(slot) ? representativeSplitModule(slot) : slot;
      var thumbSrc = mod && (mod.productImage || mod.featuredImage || mod.image);
      var thumb = thumbSrc
        ? '<img src="' + thumbSrc + '" alt="" class="position-slot-thumb" width="50" height="50">'
        : '<span class="position-slot-thumb position-slot-thumb--empty"></span>';
      return '<div class="position-slot-summary">'
        + thumb
        + '<span class="position-slot-summary-text font-type-5">' + escapeHtml(buildSlotSummary(slot)) + '</span>'
        + '<button type="button" class="position-slot-action font-type-5" data-slot-expand="' + slotNum + '">' + (I18N.change || 'Change') + '</button>'
        + '</div>';
    }
    return '<div class="position-slot-summary position-slot-summary--empty">'
      + '<span class="position-slot-thumb position-slot-thumb--empty"></span>'
      + '<span class="position-slot-summary-text font-type-5">' + (I18N.chooseYourModule || 'Choose your module') + '</span>'
      + '<button type="button" class="position-slot-action font-type-5" data-slot-expand="' + slotNum + '">' + (I18N.edit || 'Edit') + '</button>'
      + '</div>';
  }

  function assignDraftLayout(draft, layout) {
    draft.layoutIndex = data.layouts.indexOf(layout);
    if (isSplitLayout(layout)) {
      draft.layout = Object.assign({}, layout, { products: excludeDoubleWidthModules(layout.products) });
      draft.layoutMode = 'double';
      resetSplitHalves(draft);
      draft.moduleFinish = null;
      draft.switchType = null;
    } else {
      draft.layout = layout;
      draft.layoutMode = 'single';
      draft.halves = null;
      if (!draft.moduleFinish) draft.moduleFinish = defaultModuleFinish(draft.category);
    }
  }

  function renderPositionExpanded(slotNum) {
    var draft = ensureSlotDraft(slotNum);
    var html = renderCategoryGrid(slotNum, draft);

    if (draft.category) {
      var layouts = getLayoutsForCategory(draft.category);
      var needsVariant = categoryNeedsVariantStep(draft.category);

      if (!draft.layout) {
        if (layouts.length === 1 && !needsVariant) {
          assignDraftLayout(draft, layouts[0]);
        } else if (!needsVariant && layouts.length > 1) {
          html += renderLayoutPickGrid(slotNum, layouts, draft);
        }
      }

      // Single / double (or other pairable variant) — always shown until layout picked
      if (needsVariant) {
        html += renderVariantGrid(slotNum, draft);
      }

      // Finish, switch type, and product only after single vs double is chosen
      if (draft.layout) {
        var configClass = 'position-slot-module-config'
          + (needsVariant ? ' position-slot-module-config--after-variant' : '');
        html += '<div class="' + configClass + '">';
        html += renderModuleConfiguration(slotNum, draft);
        html += '</div>';
      }
    }

    return '<div class="position-slot-body">' + html + '</div>';
  }

  function renderModuleConfiguration(slotNum, draft) {
    if (isSplitLayoutForDraft(draft)) {
      return renderSplitHalves(slotNum, draft);
    }

    var html = renderFitChoice(slotNum, draft, null);
    var fit = fitModeFor(draft, draft);
    if (fit === 'cutout') return html + renderCutoutGrid(slotNum, draft, null);
    if (fit !== 'module') return html;
    html += renderFinishGrid(slotNum, draft, null);
    if (switchTypesReady(draft.category, draft.moduleFinish)
        && getSwitchTypes(draft.category, draft.layout, draft.moduleFinish).length) {
      html += renderSwitchTypeGrid(slotNum, draft, null);
    }
    html += renderProductPickGrid(slotNum, draft, null);
    return html;
  }

  // Column labels for a split slot. LEFT/RIGHT reads naturally for a 2-way pair; a
  // 3-way stack has no left/middle/right reading, so plain ordinals.
  function halfLabelsForLayout(layout) {
    var keys = halfKeysForLayout(layout);
    if (keys.length <= 2) return [I18N.left || 'LEFT', I18N.right || 'RIGHT'];
    return keys.map(function (k, i) { return String(i + 1); });
  }

  function renderSplitHalves(slotNum, draft) {
    var keys = halfKeysForLayout(draft.layout);
    var labels = halfLabelsForLayout(draft.layout);
    return '<div class="position-slot-split">'
      + keys.map(function (k, i) { return renderHalfColumn(slotNum, draft, k, labels[i]); }).join('')
      + '</div>';
  }

  function renderHalfColumn(slotNum, draft, half, label) {
    var pick = ensureHalfDraft(draft, half);
    var done = !!pick.module;
    var html = '<div class="position-slot-half' + (done ? ' position-slot-half--done' : '') + '">'
      + '<h6 class="position-slot-half-title font-type-3-bold">' + escapeHtml(label) + '</h6>';

    if (!done) {
      html += renderFitChoice(slotNum, draft, half);
      var halfFit = fitModeFor(draft, pick);
      if (halfFit === 'cutout') {
        html += renderCutoutGrid(slotNum, draft, half);
      } else if (halfFit === 'module') {
        html += renderFinishGrid(slotNum, draft, half);
        if (switchTypesReady(draft.category, pick.moduleFinish)
            && getSwitchTypes(draft.category, draft.layout, pick.moduleFinish).length) {
          html += renderSwitchTypeGrid(slotNum, draft, half);
        }
        html += renderProductPickGrid(slotNum, draft, half);
      }
    } else {
      // BugHerd #190 — show the chosen module as image | copy | Change (right),
      // reusing the collapsed-slot summary row instead of stacked text-then-button.
      var doneMod = pick.module;
      var doneThumb = doneMod && (doneMod.productImage || doneMod.featuredImage || doneMod.image);
      html += '<div class="position-slot-summary">'
        + (doneThumb
            ? '<img src="' + doneThumb + '" alt="" class="position-slot-thumb" width="50" height="50">'
            : '<span class="position-slot-thumb position-slot-thumb--empty"></span>')
        + '<span class="position-slot-summary-text font-type-5">' + escapeHtml(doneMod.displayTitle || doneMod.title) + '</span>'
        + '<button type="button" class="position-slot-action font-type-5" data-slot-num="' + slotNum + '"'
        + ' data-slot-half-reset="' + half + '">' + (I18N.change || 'Change') + '</button>'
        + '</div>';
    }

    html += '</div>';
    return html;
  }

  function renderCategoryGrid(slotNum, draft) {
    var categories = data.moduleCategories || [];
    if (!categories.length) {
      categories = [
        { value: 'toggle', label: 'Toggle' },
        { value: 'dimmer', label: 'Dimmer' },
        { value: 'rocker', label: 'Rocker' },
        IS_US ? { value: 'outlet', label: 'Outlet' } : { value: 'socket', label: 'Socket' },
        { value: 'keystone', label: 'Keystone' }
      ];
    }
    categories = categories.filter(function (cat) { return categoryHasModules(cat.value); });

    categories = categories.filter(function (cat) {
      return getLayoutsForCategory(cat.value).length > 0;
    });

    var cards = categories.map(function (cat) {
      var selected = draft.category === cat.value ? ' selected' : '';
      var catImage = resolveCategoryImage(cat);
      var img = catImage
        ? '<img src="' + catImage + '" alt="" class="module-category-thumb" width="50" height="50" loading="lazy">'
        : '<span class="module-category-thumb module-category-thumb--placeholder" aria-hidden="true">'
          + escapeHtml((cat.label || cat.value || '?').charAt(0).toUpperCase())
          + '</span>';
      var tooltipText = cat.tooltip || '';
      var info = renderModuleInfoBtn(tooltipText, fillTokens(I18N.moreInfoAbout || 'More information about __NAME__', { '__NAME__': cat.label }));
      return '<div class="module-category-item">'
        + '<button type="button" class="module-category-card font-type-5' + selected + '"'
        + ' data-slot-num="' + slotNum + '"'
        + ' data-slot-category="' + escapeAttr(cat.value) + '">'
        + img
        + '<span class="module-category-label">' + escapeHtml(cat.label) + '</span>'
        + '</button>'
        + info
        + '</div>';
    }).join('');

    // "Leave blank" (skip) sits with the categories: it is a whole-position choice.
    if (canSkipPosition(slotNum)) {
      var skipSelected = !draft.category && isSkipSlot(state.slots[slotNum]);
      cards += '<div class="module-category-item">'
        + '<button type="button" class="module-category-card module-category-card--skip font-type-5' + (skipSelected ? ' selected' : '') + '"'
        + ' data-slot-num="' + slotNum + '"'
        + ' data-slot-skip="1">'
        + '<span class="module-category-thumb module-category-thumb--placeholder module-category-thumb--skip" aria-hidden="true"></span>'
        + '<span class="module-category-label">' + escapeHtml(I18N.leaveBlank || 'Leave blank') + '</span>'
        + '</button>'
        + renderModuleInfoBtn(I18N.leaveBlankTip || 'This position is left as plain plate – no hole is cut.', fillTokens(I18N.moreInfoAbout || 'More information about __NAME__', { '__NAME__': I18N.leaveBlank || 'Leave blank' }))
        + '</div>';
    }

    var gridClass = 'module-category-grid'
      + ((draft.category || isSkipSlot(state.slots[slotNum])) ? ' module-category-grid--has-selection' : '');

    return '<div class="' + gridClass + '">' + cards + '</div>';
  }

  function renderVariantGrid(slotNum, draft) {
    var pair = resolveVariantPair(draft.category);
    // Translated category label from the module_category blocks (the raw key is
    // English-only and broke on translated storefronts). Lowercase only when the
    // label is just the capitalised key (i.e. untranslated English), preserving
    // the original sentence-case "Single toggle" / "Double toggle" design; a real
    // translation keeps its own casing (German nouns etc.).
    var catLabel = categoryLabel(draft.category);
    if (catLabel.toLowerCase() === (draft.category || '').toLowerCase()) catLabel = catLabel.toLowerCase();

    function variantCard(layout, label, variantMode) {
      if (!layout) return '';
      var idx = data.layouts.indexOf(layout);
      var selected = isVariantSelected(draft, idx, variantMode) ? ' selected' : '';
      var imgSrc = resolveLayoutPanelImage(layout);
      var img = imgSrc
        ? '<img src="' + imgSrc + '" alt="" class="module-option-thumb" width="50" height="50">'
        : '<span class="module-option-thumb module-option-thumb--empty"></span>';
      return '<button type="button" class="module-option-card font-type-5' + selected + '"'
        + ' data-slot-num="' + slotNum + '"'
        + ' data-slot-layout-index="' + idx + '"'
        + ' data-slot-variant-mode="' + variantMode + '">'
        + img + '<span>' + label + '</span></button>';
    }

    var row = ''
      + variantCard(pair.single, fillTokens(I18N.singleLabel || 'Single __CATEGORY__', { '__CATEGORY__': escapeHtml(catLabel) }), 'single')
      + variantCard(pair.double, fillTokens(I18N.doubleLabel || 'Double __CATEGORY__', { '__CATEGORY__': escapeHtml(catLabel) }), 'double');

    return '<div class="module-subsection">'
      + '<h5 class="module-subsection-title font-type-3">' + fillTokens(I18N.singleOrDoubleHeading || 'SINGLE OR DOUBLE __CATEGORY__', { '__CATEGORY__': categoryLabel(draft.category).toUpperCase() }) + '</h5>'
      + '<div class="module-option-grid module-option-grid--pair'
        + ((draft.layoutMode === 'single' || draft.layoutMode === 'double') ? ' module-option-grid--has-selection' : '')
        + '">' + row + '</div>'
      + '</div>';
  }

  function renderLayoutPickGrid(slotNum, layouts, draft) {
    var cards = layouts.map(function (layout) {
      var idx = data.layouts.indexOf(layout);
      var selected = draft.layoutIndex === idx ? ' selected' : '';
      var imgSrc = resolveLayoutPanelImage(layout);
      var img = imgSrc
        ? '<img src="' + imgSrc + '" alt="" class="module-option-thumb" width="50" height="50" loading="lazy">'
        : '<span class="module-option-thumb module-option-thumb--empty"></span>';
      return '<button type="button" class="module-option-card font-type-5' + selected + '"'
        + ' data-slot-num="' + slotNum + '"'
        + ' data-slot-layout-index="' + idx + '">'
        + img
        + '<span>' + escapeHtml(layout.name) + '</span></button>';
    }).join('');
    return '<div class="module-subsection"><div class="module-option-grid">' + cards + '</div></div>';
  }

  function renderFinishGrid(slotNum, draft, half) {
    var pick = draftPickState(draft, half);
    sanitizePickFinish(pick, draft.category);
    var finishes = getModuleFinishesForCategory(draft.category);
    if (!finishes.length) return '';

    var halfAttr = half ? ' data-slot-half="' + half + '"' : '';

    var cards = finishes.map(function (f) {
      var unavailable = isModuleFinishUnavailable(f);
      var selected = pick.moduleFinish === f.value ? ' selected' : '';
      var swatch = f.swatchImage
        ? '<img src="' + f.swatchImage + '" alt="" class="module-finish-swatch" width="33" height="33">'
        : '<span class="module-finish-swatch" style="background-color:' + (f.swatchColor || '#ccc') + '"></span>';
      // Only insert colours carry a tooltip today (regular metal finishes don't set
      // f.tooltip, so renderModuleInfoBtn returns '' for them — no visual change there).
      var info = renderModuleInfoBtn(f.tooltip, fillTokens(I18N.moreInfoAbout || 'More information about __NAME__', { '__NAME__': f.label }));
      return '<button type="button" class="module-finish-card font-type-5' + selected
        + (unavailable ? ' module-finish-card--unavailable' : '') + '"'
        + (unavailable ? ' disabled' : '')
        + ' data-slot-num="' + slotNum + '"'
        + halfAttr
        + ' data-slot-module-finish="' + escapeAttr(f.value) + '">'
        + swatch
        + '<span>' + escapeHtml(f.label) + '</span>' + info
        + '</button>';
    }).join('');

    return '<div class="module-subsection">'
      + '<h5 class="module-subsection-title font-type-3">' + finishStepLabel(draft.category) + '</h5>'
      + '<div class="module-finish-grid' + (pick.moduleFinish ? ' module-finish-grid--has-selection' : '') + '">' + cards + '</div>'
      + '</div>';
  }

  function switchTypeStepLabel(categoryKey) {
    if (categoryKey === 'socket' || categoryKey === 'outlet') return I18N.socketType || 'SOCKET TYPE';
    if (categoryKey === 'keystone') return I18N.keystoneType || 'KEYSTONE TYPE';
    return fillTokens(I18N.switchTypeHeading || '__CATEGORY__ SWITCH TYPE', { '__CATEGORY__': (categoryKey ? categoryLabel(categoryKey) : 'module').toUpperCase() });
  }

  // Price summary for a switch-type card: { cents: lowest price among the products
  // matching this finish + switch type, from: whether those matches span more than
  // one price }. null if none match / finish not chosen. Shows the cost inline on the
  // card (#457); the "from €X" framing (vs the old "+ €X") stops it reading as an
  // add-on that stacks with the per-product price at the module step (#202b).
  function switchTypeAddPrice(draft, pick, typeValue) {
    if (!draft.layout || !pick.moduleFinish) return null;
    var matches = (draft.layout.products || []).filter(function (p) {
      return productMatchesModuleFinish(p, pick.moduleFinish, draft.category)
        && productMatchesPlateFinishForCategory(p, draft.category)
        && productMatchesSwitchType(p, typeValue, draft.category, draft.layout, pick.moduleFinish);
    });
    if (!matches.length) return null;
    var min = matches.reduce(function (m, p) { return p.price < m ? p.price : m; }, matches[0].price);
    return { cents: min, from: matches.some(function (p) { return p.price !== min; }) };
  }

  function renderSwitchTypeGrid(slotNum, draft, half) {
    var pick = draftPickState(draft, half);
    var types = getSwitchTypes(draft.category, draft.layout, pick.moduleFinish);
    if (!types.length) return '';

    var halfAttr = half ? ' data-slot-half="' + half + '"' : '';
    var isLongList = isInsertCategory(draft.category);
    var gridClass = 'module-option-grid module-option-grid--switch-type'
      + (isLongList ? ' module-option-grid--long-list' : '')
      + (pick.switchType ? ' module-option-grid--has-selection' : '');

    var cards = types.map(function (t) {
      var selected = pick.switchType === t.value ? ' selected' : '';
      var imgSrc = resolveSwitchTypeImage(t, draft.layout, pick.moduleFinish, draft.category);
      var img = imgSrc
        ? '<img src="' + imgSrc + '" alt="" class="module-option-thumb" width="50" height="50" loading="lazy">'
        : '';
      var info = renderModuleInfoBtn(t.tooltip, fillTokens(I18N.moreInfoAbout || 'More information about __NAME__', { '__NAME__': t.label }));
      var price = switchTypeAddPrice(draft, pick, t.value);
      var priceHtml = '';
      if (price) {
        var priceText = price.from
          ? fillTokens(I18N.priceFrom || 'from __PRICE__', { '__PRICE__': formatPrice(price.cents) })
          : formatPrice(price.cents);
        priceHtml = '<span class="module-option-price">' + priceText + '</span>';
      }
      // Info (i) sits INSIDE the card, inline right after the name (#201). It's a
      // <span role="button"> (a <button> can't nest in the card <button>), so the JS
      // hover/click delegation (closest('[data-info-tooltip]')) still drives it.
      return '<div class="module-option-item">'
        + '<button type="button" class="module-option-card module-option-card--wide font-type-5' + selected + '"'
        + ' data-slot-num="' + slotNum + '"'
        + halfAttr
        + ' data-slot-switch-type="' + escapeAttr(t.value) + '">'
        + img
        + '<span>' + escapeHtml(t.label) + '</span>' + info + priceHtml
        + '</button>'
        + '</div>';
    }).join('');

    var gridWrap = isLongList
      ? '<div class="module-option-grid-scroll"><div class="' + gridClass + '">' + cards + '</div></div>'
      : '<div class="' + gridClass + '">' + cards + '</div>';

    return '<div class="module-subsection">'
      + '<h5 class="module-subsection-title font-type-3">' + switchTypeStepLabel(draft.category) + '</h5>'
      + gridWrap
      + '</div>';
  }

  // Label for a product card on the "choose module" step. When the products differ
  // only by insert colour (rocker Option 2: black vs white for one finish+type), the
  // colour is the meaningful distinction, so label by the (translatable) insert-colour
  // name keyed off the locale-stable insert_colour metafield. Otherwise show the
  // cleaned product name (drop the finish suffix, #204).
  function productPickLabel(product) {
    var name = stripFinishSuffix(product.title);
    // Rocker (Option 2): the two cards differ only by insert colour, so keep the product
    // name and append the (translatable) colour — e.g. "Two Way Rocker Switch - White".
    // The already-chosen metal finish (redundant here) is dropped by stripFinishSuffix.
    if (product.insertColour) {
      var match = getInsertColours().filter(function (c) { return c.value === product.insertColour; })[0];
      if (match) return name + ' - ' + match.label;
    }
    return name;
  }

  function renderProductPickGrid(slotNum, draft, half) {
    var pick = draftPickState(draft, half);
    if (!pick.moduleFinish) return '';
    var types = getSwitchTypes(draft.category, draft.layout, pick.moduleFinish);
    if (types.length > 0 && !pick.switchType) return '';

    var products = filteredProductsForDraft(slotNum, half);
    if (!products.length) {
      return '<div class="module-subsection module-subsection--empty">'
        + '<p class="module-subsection-hint font-type-5">' + (I18N.noMatch || 'No products match this finish and switch type.') + '</p>'
        + '</div>';
    }
    // BugHerd #189 — a sole matching product is auto-committed (incl. split halves,
    // see maybeAutoPickProduct), so never show a redundant one-card "CHOOSE MODULE".
    if (products.length === 1) return '';

    var halfAttr = half ? ' data-slot-half="' + half + '"' : '';

    var cards = products.map(function (p) {
      var imgSrc = resolveProductPickImage(p);
      var img = imgSrc
        ? '<img src="' + imgSrc + '" alt="" class="module-option-thumb" width="50" height="50" loading="lazy">'
        : '<span class="module-option-thumb module-option-thumb--empty"></span>';
      return '<button type="button" class="module-option-card module-option-card--product font-type-5"'
        + ' data-slot-num="' + slotNum + '"'
        + halfAttr
        + ' data-slot-product-id="' + p.id + '">'
        + img
        + '<span>' + escapeHtml(productPickLabel(p)) + '</span>'
        + '<span class="module-option-price">' + formatPrice(p.price) + '</span>'
        + '</button>';
    }).join('');

    return '<div class="module-subsection">'
      + '<h5 class="module-subsection-title font-type-3">' + (I18N.chooseModule || 'CHOOSE MODULE') + '</h5>'
      + '<div class="module-product-grid">' + cards + '</div>'
      + '</div>';
  }

  var activeTooltip = null;
  var activeTooltipAnchor = null;

  // Locale strings arrive HTML-escaped (Shopify's `t` filter turns ' into &#39;), and the
  // tooltip is set as textContent, so decode them or the customer sees "It&#39;s".
  function decodeEntities(str) {
    var el = document.createElement('textarea');
    el.innerHTML = str;
    return el.value;
  }

  function showInfoTooltip(anchor, text) {
    if (activeTooltipAnchor === anchor) return; // already showing for this btn
    hideInfoTooltip();
    if (!text) return;
    var tip = document.createElement('div');
    tip.className = 'module-info-tooltip';
    tip.setAttribute('role', 'tooltip');
    tip.textContent = decodeEntities(text);
    document.body.appendChild(tip);

    var pad = 12;
    var vw = window.innerWidth;
    var maxW = Math.min(344, vw - pad * 2);
    tip.style.maxWidth = maxW + 'px';
    tip.style.boxSizing = 'border-box';

    var rect = anchor.getBoundingClientRect();
    var tipW = tip.getBoundingClientRect().width;
    var anchorCentre = rect.left + rect.width / 2;
    var left = anchorCentre - tipW / 2;
    left = Math.max(pad, Math.min(left, vw - pad - tipW));

    // Point the caret at the button even when the box is clamped to the viewport.
    var caretX = Math.max(16, Math.min(anchorCentre - left, tipW - 16));
    tip.style.setProperty('--caret-x', caretX + 'px');

    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    tip.style.left = left + 'px';
    if (isMobile) {
      tip.style.position = 'fixed';
      tip.style.top = (rect.bottom + 8) + 'px';
    } else {
      tip.style.position = 'absolute';
      tip.style.top = (rect.bottom + 8 + window.scrollY) + 'px';
    }

    activeTooltip = tip;
    activeTooltipAnchor = anchor;
    setTimeout(function () {
      document.addEventListener('click', hideInfoTooltip, { once: true });
    }, 0);
  }

  function hideInfoTooltip() {
    if (activeTooltip) {
      activeTooltip.remove();
      activeTooltip = null;
      activeTooltipAnchor = null;
    }
  }

  function escapeAttr(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');
  }

  // Wipe any entered engraving text, collapse to the zero state, and
  // clear any error flag. Called whenever the plate or modules change
  // in a way that could invalidate existing position keys.
  function resetEngraving() {
    state.engraving.enabled = false;
    state.engraving.values = {};
    state.engraving.validityErrors = 0;
    if (engravingOverlay) {
      engravingOverlay.innerHTML = '';
      engravingOverlay.hidden = true;
    }
    if (engravingError) engravingError.hidden = true;
  }

  // ----------------------------------------------------------------
  // Engraving — Step 3
  //
  // Engraving is a flat-fee add-on: one price regardless of how many
  // positions the customer engraves. The fee is sourced from a theme
  // section setting (a product reference, one per regional store) and
  // appears as a separate bundle child line in cart so the bundler
  // Cart Transform groups it with the plate and modules.
  //
  // Positions are derived in mm-space from existing plate/layout data:
  // per plate, engraving_above_offset_mm / engraving_below_offset_mm
  // give the vertical baselines above/below each slot's Y-centre. Per
  // layout, engraving_max_width_single_mm / engraving_max_width_half_mm
  // (or engraving_max_widths_mm as fallback) set validation width per
  // line; pairable layouts use half width for split toggles, non-pairable
  // layouts with two half widths use inline 1a/1b positioning (double
  // rocker). engraving_pitch_mm applies only to multi-line pitch layouts.
  // ----------------------------------------------------------------

  // data.plates is keyed by size_key (= state.size), not gang count — Italian Grove's 3-module
  // and 4-module plates share gang counts with Triple and Double.
  function getPlate() {
    return state.size ? (data.plates[state.size] || null) : null;
  }

  // Room for one position on the selected plate: the centre-to-centre pitch on a multi-position
  // plate (Italian Grove 3-module = 22.5mm), unlimited on a 1-position plate.
  function positionWidthMm() {
    var plate = getPlate();
    if (!plate || !(Number(plate.cols) > 1) || !(Number(plate.pitchX) > 0)) return Infinity;
    return Number(plate.pitchX);
  }

  // Does a layout fit one position? A pairable layout's double (split) mode spans width × 2.5
  // (see the split-span helper above); everything else spans its own width. Half a millimetre
  // of tolerance for rounding in the data. Layouts with no width always fit.
  function layoutFitsPosition(layout, mode) {
    var w = Number(layout && layout.widthMm) || 0;
    if (!w) return true;
    var span = (mode === 'double' && layout.pairable) ? w * 2.5 : w;
    return span <= positionWidthMm() + 0.5;
  }

  // plate_height_mm on bespoke_plates is optional. When absent, derive
  // it from the plate image's natural aspect ratio — the image is a
  // true-to-life render of the physical plate, so its pixel aspect
  // ratio matches its mm aspect ratio. Last-resort fallback is the
  // width, which only matches for square plates (1-gang).
  function resolvePlateHeightMm(plate, plateWidthMm) {
    var explicit = Number(plate.heightMm);
    if (explicit > 0) return explicit;
    if (plateImage
        && plateImage.naturalWidth
        && plateImage.naturalHeight
        && plateWidthMm) {
      return plateWidthMm * (plateImage.naturalHeight / plateImage.naturalWidth);
    }
    return plateWidthMm;
  }

  function plateOffsetMm(val) {
    if (val == null || val === '') return null;
    var n = Number(val);
    return isFinite(n) ? n : null;
  }

  function plateSupportsEngraving() {
    var p = getPlate();
    if (!p) return false;
    return plateOffsetMm(p.engravingAboveOffsetMm) != null
      && plateOffsetMm(p.engravingBelowOffsetMm) != null;
  }

  // Per-category engraving offsets (mm from plate top edge to text-box
  // top — the same convention as the plate-level fields), sourced from
  // the layout metaobjects so the laser's per-module heights live in
  // data, not code. Categories without values fall back to the
  // plate-level pair, which also stays the engraving-enable gate
  // (US 5/6-gang: no plate offsets = no engraving).
  //
  // In vertical orientation, a plate's row axis (module pitch) is the
  // same axis the above/below text sits along, so a wide category (e.g.
  // rocker) can push adjacent slots' text into each other in a way that
  // never happens horizontally (text there sits along the module's own
  // height instead) — see the multi-row/vertical overlap investigation.
  // A category can optionally carry vertical-specific offsets that only
  // apply when isVerticalPlatePreview() is true; unset (every category
  // today except rocker) falls through to the same horizontal pair used
  // on screen either way, so this is byte-identical until data is added.
  function categoryEngravingOffsets(categoryKey) {
    if (!categoryKey) return null;
    var layouts = data.layouts || [];
    var vertical = isVerticalPlatePreview();
    for (var i = 0; i < layouts.length; i++) {
      var l = layouts[i];
      if (l.categoryKey !== categoryKey) continue;
      if (vertical && (l.engravingAboveOffsetVerticalMm != null || l.engravingBelowOffsetVerticalMm != null)) {
        return {
          aboveMm: l.engravingAboveOffsetVerticalMm != null ? l.engravingAboveOffsetVerticalMm : l.engravingAboveOffsetMm,
          belowMm: l.engravingBelowOffsetVerticalMm != null ? l.engravingBelowOffsetVerticalMm : l.engravingBelowOffsetMm
        };
      }
      if (l.engravingAboveOffsetMm != null || l.engravingBelowOffsetMm != null) {
        return { aboveMm: l.engravingAboveOffsetMm, belowMm: l.engravingBelowOffsetMm };
      }
    }
    return null;
  }

  function slotCategoryKey(slot) {
    if (!slot) return null;
    if (slot._pickMeta && slot._pickMeta.category) return slot._pickMeta.category;
    var rep = slot.split ? representativeSplitModule(slot) : slot;
    var found = rep && rep.id ? findLayoutForProduct(rep.id) : null;
    return found ? found.layout.categoryKey : null;
  }

  // One engraving row per plate side, positioned by the outermost
  // requirement among the modules present: small modules (toggles,
  // dimmers) pull the text in to hug them, but a single rocker/socket
  // pushes every engraving back out to the edges to make space. Each
  // filled slot contributes its category's offsets (or the plate
  // defaults when the category has none); smallest above / largest
  // below wins so the row clears the tallest module.
  function effectiveEngravingOffsets() {
    var plate = getPlate();
    if (!plate) return null;
    var plateAbove = plateOffsetMm(plate.engravingAboveOffsetMm);
    var plateBelow = plateOffsetMm(plate.engravingBelowOffsetMm);
    if (plateAbove == null || plateBelow == null) return null;
    var above = null;
    var below = null;
    for (var i = 1; i <= state.gangCount; i++) {
      var slot = state.slots[i];
      if (!slot || isSkipSlot(slot)) continue;
      var offs = categoryEngravingOffsets(slotCategoryKey(slot));
      var slotAbove = offs && offs.aboveMm != null ? offs.aboveMm : plateAbove;
      var slotBelow = offs && offs.belowMm != null ? offs.belowMm : plateBelow;
      if (above == null || slotAbove < above) above = slotAbove;
      if (below == null || slotBelow > below) below = slotBelow;
    }
    return {
      aboveMm: above != null ? above : plateAbove,
      belowMm: below != null ? below : plateBelow
    };
  }

  function slotHasEngraving(slot) {
    if (!slot) return false;
    if (slot.split) {
      return halfKeysForSlot(slot).some(function (k) {
        return !!slot[k] && hasEngravingWidths(enrichEngravingRep(slot[k]));
      });
    }
    return hasEngravingWidths(enrichEngravingRep(slot));
  }

  // True when the current configuration can be engraved at all: fee
  // product configured, plate has baselines, and at least one filled
  // slot has a layout with widths declared. Used for step skipping and
  // for hiding the engraving indicator item.
  function engravingAvailable() {
    if (!getEngravingFee()) return false;
    if (state.finish === PAINTABLE_FINISH) return false; // paintable plates can't be engraved
    if (!plateSupportsEngraving()) return false;
    if (!state.gangCount) return false;
    for (var i = 1; i <= state.gangCount; i++) {
      if (slotHasEngraving(state.slots[i])) return true;
    }
    return false;
  }

  function hasEngravingWidths(rep) {
    return !!(rep && rep.engravingMaxWidthsMm && rep.engravingMaxWidthsMm.length > 0);
  }

  function findLayoutWithEngravingWidths(moduleObj) {
    if (!moduleObj || !moduleObj.widthMm) return null;
    return (data.layouts || []).find(function (l) {
      if (l.widthMm !== moduleObj.widthMm) return false;
      return (l.engravingMaxWidthsMm && l.engravingMaxWidthsMm.length > 0)
        || Number(l.engravingMaxWidthSingleMm) > 0
        || Number(l.engravingMaxWidthHalfMm) > 0;
    }) || null;
  }

  function enrichEngravingRep(rep) {
    if (!rep || hasEngravingWidths(rep)) return rep;
    var layout = findLayoutWithEngravingWidths(rep);
    if (!layout) return rep;
    var mode = rep.engravingMode
      || (moduleUsesInlineDoubleEngraving(rep) ? 'inline-double' : 'single');
    return {
      id: rep.id,
      title: rep.title,
      price: rep.price,
      image: rep.image,
      productImage: rep.productImage,
      widthMm: rep.widthMm,
      engravingMaxWidthsMm: resolveEngravingWidths(layout, mode).slice(),
      engravingPitchMm: layout.engravingPitchMm || 0,
      engravingMode: mode,
      inlineDoubleEngraving: moduleUsesInlineDoubleEngraving(rep),
      inlineSplitEngraving: mode === 'inline-double'
    };
  }

  function pushInlineSplitEngravingPairs(result, slotNum, rep, slotCentreXMm, slotCentreYMm, plateWidthMm, plateHeightMm) {
    rep = enrichEngravingRep(rep);
    var widths = rep.engravingMaxWidthsMm || [];
    if (widths.length < 2) return;

    ['a', 'b'].forEach(function (half, idx) {
      if (!widths[idx]) return;
      pushEngravingPairsForRep(
        result, slotNum, rep,
        slotCentreXMm, slotCentreYMm, rep, plateWidthMm, plateHeightMm,
        half, widths[idx]
      );
    });
  }

  // Engraving cart-property key (after the 'Engraving | ' prefix added at cart time):
  // `Position 2a (Above)`. Was `Switch …` until the 2026-09 Position-everywhere cutover
  // agreed with the ERP (Oskar); App-Hub and the basket accept both.
  function engravingPropertyKey(posKey, placement) {
    return 'Position ' + posKey + ' (' + placement + ')';
  }

  // Push engraving pairs for one module at a given plate position.
  // posKeySuffix is set for split-slot halves ('a' / 'b') and inline
  // double-rocker lines; widthMmOverride sets validation width per line.
  function pushEngravingPairsForRep(result, slotNum, rep, slotCentreXMm, slotCentreYMm, ref, plateWidthMm, plateHeightMm, posKeySuffix, widthMmOverride) {
    rep = enrichEngravingRep(rep);
    if (!hasEngravingWidths(rep)) return;

    var widths = rep.engravingMaxWidthsMm;
    var pitch  = rep.engravingPitchMm || 0;

    // Split-slot halves and inline double-rocker — one engraving line
    // each, positioned like a split gang (±span/4 from centre).
    if (posKeySuffix) {
      var posKey = String(slotNum) + posKeySuffix;
      var halfCenter = moduleOverlayCenterPercent(
        slotCentreXMm, slotCentreYMm, posKeySuffix, ref, plateWidthMm, plateHeightMm, 0
      );
      var lineWidth = widthMmOverride != null ? widthMmOverride : widths[0];
      result.push({
        slotNum: slotNum,
        suffix: posKeySuffix,
        posKey: posKey,
        overlayLeftPct: halfCenter.leftPct,
        overlayTopPct: halfCenter.topPct,
        widthMm: lineWidth,
        aboveKey: engravingPropertyKey(posKey, 'Above'),
        belowKey: engravingPropertyKey(posKey, 'Below')
      });
      return;
    }

    var K = widths.length;

    for (var k = 0; k < K; k++) {
      var offsetXMm = (K === 1) ? 0 : (k - (K - 1) / 2) * pitch;
      var suffix = (K === 1) ? '' : String.fromCharCode(97 + k);
      var pairKey = String(slotNum) + suffix;
      var overlayCenter = moduleOverlayCenterPercent(
        slotCentreXMm, slotCentreYMm, null, null, plateWidthMm, plateHeightMm, offsetXMm
      );
      result.push({
        slotNum: slotNum,
        suffix: suffix,
        posKey: pairKey,
        overlayLeftPct: overlayCenter.leftPct,
        overlayTopPct: overlayCenter.topPct,
        widthMm: widths[k],
        aboveKey: engravingPropertyKey(pairKey, 'Above'),
        belowKey: engravingPropertyKey(pairKey, 'Below')
      });
    }
  }

  // Flat list of engraving pairs across the whole plate. Each pair
  // corresponds to one text box on the plate and has its own cart
  // property keys (Above + Below). posKey is the slot number for
  // single-engraving layouts or slotNum + letter suffix for multi
  // (e.g. '2a', '2b'), mirroring the existing Position Na/Nb naming
  // used for split-slot module properties.
  function allEngravingPairs() {
    var result = [];
    var plate = getPlate();
    if (!plate) return result;

    var cols = plate.cols || state.gangCount;
    var rows = plate.rows || 1;
    var pitchX = plate.pitchX || 0;
    var pitchY = plate.pitchY || 0;

    var plateWidthMm = Number(plate.widthMm) || 0;
    var plateHeightMm = resolvePlateHeightMm(plate, plateWidthMm);

    for (var i = 1; i <= state.gangCount; i++) {
      var slot = state.slots[i];
      if (!slot) continue;

      var col = (i - 1) % cols;
      var row = Math.floor((i - 1) / cols);
      var slotCentreXMm = (col - (cols - 1) / 2) * pitchX;
      var slotCentreYMm = (row - (rows - 1) / 2) * pitchY;

      if (slot.split) {
        var ref = representativeSplitModule(slot);
        if (slotStacksVertically(slot)) {
          // Vertically stacked position (US keystones): at most ONE engraving for the
          // whole stack, not one per part. Reuse the plain whole-slot path (posKeySuffix
          // '') so the cart-property naming matches an unsplit position ("Switch 2
          // (Above)") and the line is centred on the position, not on any one keystone.
          if (ref) {
            pushEngravingPairsForRep(
              result, i, ref,
              slotCentreXMm, slotCentreYMm, null, plateWidthMm, plateHeightMm,
              '', null
            );
          }
          continue;
        }
        // Side-by-side pair (EU): one engraving line per part, positioned like a split gang.
        halfKeysForSlot(slot).forEach(function (k) {
          var part = slot[k];
          if (!part) return;
          pushEngravingPairsForRep(
            result, i, part,
            slotCentreXMm, slotCentreYMm, ref, plateWidthMm, plateHeightMm,
            k, part.engravingMaxWidthsMm && part.engravingMaxWidthsMm[0]
          );
        });
        continue;
      }

      if (slotUsesInlineSplitEngraving(slot)) {
        pushInlineSplitEngravingPairs(
          result, i, slot, slotCentreXMm, slotCentreYMm, plateWidthMm, plateHeightMm
        );
        continue;
      }

      pushEngravingPairsForRep(
        result, i, slot,
        slotCentreXMm, slotCentreYMm, null, plateWidthMm, plateHeightMm,
        '', null
      );
    }
    return result;
  }

  function hasEngravingText() {
    // Guards the cart properties + fee: engraving typed under an earlier
    // config must never ship once the config can no longer be engraved.
    if (!engravingAvailable()) return false;
    return Object.keys(state.engraving.values).some(function (key) {
      return String(state.engraving.values[key] || '').trim() !== '';
    });
  }

  function syncEngravingEnabledFromValues() {
    state.engraving.enabled = hasEngravingText();
  }

  function renderEngravingStep() {
    // Step 3 is always navigable — if engraving can't be produced for
    // the current configuration we render an informational message
    // here rather than hiding the step or auto-skipping. Continue
    // stays enabled so the customer can move on to Review.
    var pairs = engravingAvailable() ? allEngravingPairs() : [];

    if (pairs.length === 0) {
      // Any engraving state left over from a previous compatible
      // config would be stale, so clear it — otherwise the fee could
      // still be applied silently.
      resetEngraving();
      engravingFeeBadge.hidden = true;
      if (engravingError) engravingError.hidden = true;
      engravingOverlay.innerHTML = '';
      engravingOverlay.hidden = true;
      engravingInputs.innerHTML =
        '<p class="builder-engraving-empty font-type-5">'
        + (I18N.engravingUnavailable || 'Engraving isn\'t available for this configuration. Continue to review your order.')
        + '</p>';
      updatePriceDisplay();
      return;
    }

    // Fee badge — only shown once we've confirmed fee + plate are ready
    var engravingFee = getEngravingFee();
    if (engravingFee) {
      engravingFeeBadge.textContent = '+ ' + formatPrice(engravingFee.price);
      engravingFeeBadge.hidden = false;
    }

    var rowsHtml = pairs.map(function (p) {
      var aboveVal = escapeHtml(state.engraving.values[p.aboveKey] || '');
      var belowVal = escapeHtml(state.engraving.values[p.belowKey] || '');
      return ''
        + '<section class="engraving-block" data-pos="' + p.posKey + '">'
        +   '<h4 class="engraving-block-title font-type-3">' + engravingDisplayLabel(p.posKey) + '</h4>'
        +   '<div class="engraving-fields-row">'
        +     '<label class="engraving-field-legend font-type-4" for="' + escapeAttr(p.aboveKey) + '">' + (I18N.engravingAboveLabel || 'Above') + '</label>'
        +     '<input class="engraving-input font-type-5" type="text" id="' + escapeAttr(p.aboveKey) + '" name="' + escapeAttr(p.aboveKey) + '" value="' + aboveVal + '" autocomplete="off" placeholder="' + escapeAttr(I18N.engravingOptionalPlaceholder || 'Optional') + '">'
        +     '<label class="engraving-field-legend font-type-4" for="' + escapeAttr(p.belowKey) + '">' + (I18N.engravingBelowLabel || 'Below') + '</label>'
        +     '<input class="engraving-input font-type-5" type="text" id="' + escapeAttr(p.belowKey) + '" name="' + escapeAttr(p.belowKey) + '" value="' + belowVal + '" autocomplete="off" placeholder="' + escapeAttr(I18N.engravingOptionalPlaceholder || 'Optional') + '">'
        +   '</div>'
        + '</section>';
    }).join('');

    engravingInputs.innerHTML = rowsHtml;
    bindEngravingInputs();
    renderEngravingOverlay();
    // Scale after layout: spans are positioned as % of wrapper but text
    // size depends on the rendered image pixel width, which isn't known
    // until the image has its final box. rAF → next frame gives us
    // clientWidth reliably in practice.
    requestAnimationFrame(scaleEngravingOverlays);
    revalidateEngraving();
    syncEngravingEnabledFromValues();
    updatePriceDisplay();
  }

  function bindEngravingInputs() {
    var sanitize = window.sanitizeEngravingInput || function (s) { return s; };

    function applyEngravingInput(input) {
      var raw = input.value;
      var cleaned = sanitize(raw);
      if (cleaned !== raw) input.value = cleaned;

      var key = input.name;
      if (input.value.trim() === '') {
        delete state.engraving.values[key];
      } else {
        state.engraving.values[key] = input.value;
      }
      syncEngravingEnabledFromValues();

      var span = engravingOverlay.querySelector('[data-key="' + cssEscapeAttr(key) + '"]');
      if (span) {
        span.innerHTML = input.value.replace(/\|/g, '<br>');
      }

      updatePriceDisplay();
      revalidateEngraving();
    }

    engravingInputs.querySelectorAll('.engraving-input').forEach(function (input) {
      input.addEventListener('input', function () {
        applyEngravingInput(input);
      });
      input.addEventListener('change', function () {
        applyEngravingInput(input);
      });
    });
  }

  // Render one span per engraving pair's Above and Below baselines.
  // Positioning: percentages of the plate image, computed from mm-space
  // offsets from plate centre. Matches how module overlays are laid out.
  function renderEngravingOverlay() {
    engravingOverlay.innerHTML = '';
    if (!engravingAvailable()) {
      engravingOverlay.hidden = true;
      return;
    }

    var plate = getPlate();
    var plateWidthMm  = Number(plate.widthMm);
    var plateHeightMm = resolvePlateHeightMm(plate, plateWidthMm);
    if (!plateWidthMm || !plateHeightMm) return;
    var plateRows = plate.rows || 1;

    var offsets = effectiveEngravingOffsets();
    if (!offsets) return;
    var above = offsets.aboveMm;
    var below = offsets.belowMm;
    var pairs = allEngravingPairs();

    pairs.forEach(function (p) {
      var coords = engravingOverlayPosition(
        p.overlayLeftPct, p.overlayTopPct, above, below, plateWidthMm, plateHeightMm, plateRows
      );

      var aboveSpan = buildEngravingSpan(p.aboveKey, coords.aboveLeft, coords.aboveTop, p.widthMm, 'above');
      engravingOverlay.appendChild(aboveSpan);

      var belowSpan = buildEngravingSpan(p.belowKey, coords.belowLeft, coords.belowTop, p.widthMm, 'below');
      engravingOverlay.appendChild(belowSpan);
    });

    engravingOverlay.hidden = false;
  }

  function buildEngravingSpan(key, leftPct, topPct, widthMm, position) {
    var span = document.createElement('span');
    span.className = 'builder-engraving-span builder-engraving-span--' + position;
    span.dataset.key = key;
    span.dataset.maxWidthMm = widthMm;
    span.style.left = leftPct + '%';
    span.style.top = topPct + '%';
    var existing = state.engraving.values[key];
    if (existing) span.innerHTML = existing.replace(/\|/g, '<br>');
    return span;
  }

  // Ported from engraving-modal.liquid (base calibration 0.839). The
  // builder preview uses a slightly lower factor so text sits inside
  // the physical engraving zones on the plate image.
  var ENGRAVING_MODAL_CALIBRATION = 0.839;
  var ENGRAVING_FONT_SIZE_ADJUST = 0.96; // ~4% smaller than modal
  // Extra breathing room on the wrap box only — text renders at the same
  // size, it just gets slightly more width before the 2-line wrap kicks in
  // (e.g. "Dishwasher" on a double toggle wrapped its last letter; the
  // laser fits it on one line).
  var ENGRAVING_MAX_WIDTH_FUDGE = 1.02;

  function scaleEngravingOverlays() {
    var plate = getPlate();
    if (!plate || !plate.widthMm) return;

    var imageWidth = plateImage.clientWidth;
    if (!imageWidth) return;

    var referenceImageWidth = 400;
    var referencePlateWidth = 146;
    var calibrationFactor   = ENGRAVING_MODAL_CALIBRATION * ENGRAVING_FONT_SIZE_ADJUST;
    var baseScaleFactor     = (imageWidth / plate.widthMm) / (referenceImageWidth / referencePlateWidth);
    var scaleFactor         = baseScaleFactor * calibrationFactor;

    engravingOverlay.querySelectorAll('.builder-engraving-span').forEach(function (span) {
      var maxWidthMm  = parseFloat(span.dataset.maxWidthMm);
      if (!maxWidthMm) return;
      var baseMaxWidth = maxWidthMm * (referenceImageWidth / referencePlateWidth);
      span.style.maxWidth = (baseMaxWidth / calibrationFactor * ENGRAVING_MAX_WIDTH_FUDGE) + 'px';
      // Both branches pin the LOCAL top-center of the span at its positioned
      // (left, top) coordinate via transform-origin:center top + translateX(-50%)
      // only (no vertical translate) — the box then grows downward in normal
      // layout as text wraps to 2 lines, invariant to how tall it gets. The
      // vertical branch used to translate(-50%, -50%), which re-centers on the
      // box's OWN height — since a rotate(-90deg) is composed with the
      // wrapper's own rotate(90deg), that recentring resolved to the box
      // growing upward on screen as text wrapped, crashing into whatever sat
      // above it. Same top-pin pattern here, with the rotation inserted.
      span.style.transformOrigin = 'center top';
      if (isVerticalPlatePreview()) {
        span.style.transform = 'translateX(-50%) rotate(-90deg) scale(' + scaleFactor + ')';
      } else {
        span.style.transform = 'translateX(-50%) scale(' + scaleFactor + ')';
      }
    });

    revalidateEngraving();
  }

  // Walk the overlay spans, flag any whose rendered content exceeds
  // two lines (red border + error message + disables Continue). The
  // 2-line limit matches the modal's validation. Shift-on-wrap is out
  // of scope for v1 — positions stay fixed regardless of wrap.
  function revalidateEngraving() {
    if (!engravingOverlay) return;
    var errors = 0;

    engravingOverlay.querySelectorAll('.builder-engraving-span').forEach(function (span) {
      span.classList.remove('builder-engraving-span--invalid');

      var transform = window.getComputedStyle(span).transform;
      var scaleFactor = 1;
      if (transform && transform !== 'none') {
        var match = transform.match(/matrix\(([^,]+),/);
        if (match) scaleFactor = parseFloat(match[1]) || 1;
      }

      var lineHeight = parseInt(window.getComputedStyle(span).lineHeight, 10) / scaleFactor;
      var height = span.clientHeight / scaleFactor;
      var forcedBreaks = (span.innerHTML.match(/<br>/g) || []).length;
      var lines = Math.max(Math.round(height / lineHeight), forcedBreaks + 1);

      if (lines > 2) {
        span.classList.add('builder-engraving-span--invalid');
        errors += 1;
      }
    });

    state.engraving.validityErrors = errors;
    if (engravingError) engravingError.hidden = errors === 0;

    if (state.step === 3) {
      nextBtn.disabled = !validateStep(3);
    }
  }

  // querySelector(`[data-key="${key}"]`) — engraving property keys
  // contain spaces and parens, which are fine inside a quoted
  // attribute value; only the enclosing quote and a backslash need
  // escaping.
  function cssEscapeAttr(str) {
    return String(str).replace(/(["\\])/g, '\\$1');
  }

  // ----------------------------------------------------------------
  // Review — Step 4
  // ----------------------------------------------------------------

  function renderReviewSectionHead(titleHtml, changeHtml) {
    return '<div class="review-section-head">'
      + titleHtml
      + (changeHtml || '<span class="review-head-action-spacer" aria-hidden="true"></span>')
      + '</div>';
  }

  function renderReview() {
    if (!reviewContent) return;

    var plateVariant = getPlateVariant();
    var platePrice = plateVariant ? plateVariant.price : 0;
    // When the config matches a stock plate, that is what the customer
    // actually receives (decision 1), so the review shows the stock plate's
    // name + image. Price is unchanged (== bespoke, by the parity gate).
    var stockMatch = findStockPlateMatch();
    var plateSummaryText = stockMatch ? stockMatch.title : buildPlateSummaryLine();
    var plateThumbSrc = (stockMatch && stockMatch.image) || (plateVariant && plateVariant.image);
    var plateThumb = plateThumbSrc
      ? '<img src="' + plateThumbSrc + '" alt="" class="review-item-thumb" width="50" height="50" loading="lazy">'
      : '<span class="review-item-thumb review-item-thumb--empty"></span>';
    var plateChange = '<button type="button" class="review-change-btn font-type-5" data-review-change="plate">' + (I18N.change || 'Change') + '</button>';

    // Engraving is a one-off per-plate fee that covers any number of engravings
    // (BugHerd #454). The Figma review shows it inline on the engraving line under
    // its position, not as a separate trailing line — so render it once, on the
    // first engraving row (feeState.remaining is consumed by whichever renders first).
    var reviewFee = getEngravingFee();
    var feeState = { remaining: (hasEngravingText() && reviewFee) ? reviewFee.price : null };
    var positionBlocks = '';
    for (var i = 1; i <= state.gangCount; i++) {
      positionBlocks += renderReviewPositionBlock(i, feeState);
    }

    reviewContent.innerHTML = ''
      + '<section class="review-block review-block--plate">'
      +   renderReviewSectionHead(
            '<h3 class="review-block-title font-type-4">' + (I18N.reviewPlate || 'Plate') + '</h3>',
            plateChange
          )
      +   '<div class="review-line review-line--plate">'
      +     plateThumb
      +     '<span class="review-line-text font-type-5">' + escapeHtml(plateSummaryText) + '</span>'
      +     '<span class="review-line-price font-type-5">' + formatPrice(platePrice) + '</span>'
      +   '</div>'
      + '</section>'
      + '<section class="review-block review-block--modules">'
      +   '<h3 class="review-block-title review-block-title--section font-type-4">' + (I18N.reviewModules || 'Modules and optional engraving') + '</h3>'
      +   positionBlocks
      + '</section>';

    if (termsCheckbox) {
      state.termsAccepted = termsCheckbox.checked;
    }
  }

  function renderReviewPositionBlock(slotNum, feeState) {
    var slot = state.slots[slotNum];
    var changeBtn = '<button type="button" class="review-change-btn font-type-5" data-review-change="position-' + slotNum + '">' + (I18N.change || 'Change') + '</button>';

    function thumbHtml(mod) {
      return mod && mod.productImage
        ? '<img src="' + mod.productImage + '" alt="" class="review-item-thumb" width="50" height="50" loading="lazy">'
        : '<span class="review-item-thumb review-item-thumb--empty"></span>';
    }

    // Engraving lines for this slot. The one-off engraving fee (BugHerd #454) shows
    // once, on the first engraving line across all positions — consume feeState so
    // later lines stay price-less and it never reads as a per-position charge.
    // useSpacer adds the 50px thumb-column placeholder (split layout only; the
    // standard layout keeps the thumb outside the lines).
    function engravingLines(useSpacer) {
      var html = '';
      allEngravingPairs().filter(function (p) { return p.slotNum === slotNum; }).forEach(function (p) {
        var summary = formatEngravingSummary(state.engraving.values[p.aboveKey], state.engraving.values[p.belowKey]);
        if (!summary) return;
        var feePrice = '';
        if (feeState && feeState.remaining != null) {
          feePrice = formatPrice(feeState.remaining);
          feeState.remaining = null;
        }
        html += '<div class="review-line review-line--engraving">'
          + (useSpacer ? '<span class="review-item-thumb review-item-thumb--spacer" aria-hidden="true"></span>' : '')
          + '<span class="review-line-text font-type-5">' + escapeHtml(summary) + '</span>'
          + '<span class="review-line-price font-type-5">' + feePrice + '</span>'
          + '</div>';
      });
      return html;
    }

    var body;
    if (slot && slot.split) {
      // Split (pairable) layout — two module lines, each with its own thumb, then engraving.
      var lines = '';
      halfKeysForSlot(slot).map(function (k) { return slot[k]; }).forEach(function (mod) {
        if (!mod) return;
        lines += '<div class="review-line review-line--module">'
          + thumbHtml(mod)
          + '<span class="review-line-text font-type-5">' + escapeHtml(mod.displayTitle || mod.title) + '</span>'
          + '<span class="review-line-price font-type-5">' + (isSyntheticModule(mod) ? '' : formatPrice(mod.price)) + '</span>'
          + '</div>';
      });
      body = lines + engravingLines(true);
    } else {
      // Standard layout (#205, Figma 69:375) — one thumb vertically centred against the
      // stacked name + engraving lines (tight gap between them).
      var nameLine = slot
        ? '<div class="review-line review-line--module">'
            + '<span class="review-line-text font-type-5">' + escapeHtml(slot.displayTitle || slot.title) + '</span>'
            + '<span class="review-line-price font-type-5">' + (isSyntheticModule(slot) ? '' : formatPrice(slot.price)) + '</span>'
            + '</div>'
        : '';
      body = '<div class="review-position-body">'
        + thumbHtml(slot)
        + '<div class="review-position-lines">' + nameLine + engravingLines(false) + '</div>'
        + '</div>';
    }

    return '<div class="review-position">'
      + renderReviewSectionHead(
          '<h4 class="review-position-title font-type-5">' + fillTokens(I18N.positionHeading || 'Position __ORDINAL__', { '__ORDINAL__': ordinalWord(slotNum) }).toUpperCase() + '</h4>',
          changeBtn
        )
      + body
      + '</div>';
  }

  // ----------------------------------------------------------------
  // Pricing
  // ----------------------------------------------------------------

  function getPlateVariant() {
    if (!state.style || !state.finish || !state.size) return null;
    var key = state.style + '|' + state.finish + '|' + state.size;
    if (state.orientation) {
      var withOrientation = key + '|' + state.orientation;
      if (isPlateBuyable(data.plateVariants[withOrientation])) return data.plateVariants[withOrientation];
    }
    return isPlateBuyable(data.plateVariants[key]) ? data.plateVariants[key] : null;
  }

  // A plate-map entry only counts when its bespoke (B) variant can be bought in this market
  // (`available`, from snippets/switch-builder-plate-map-entry.liquid; missing = older payload).
  function isPlateBuyable(entry) {
    return !!entry && entry.available !== false;
  }

  // Is there a buyable plate for this partial selection? Omitted arguments match anything; an
  // entry with no orientation matches any orientation (getPlateVariant falls back to it). When
  // the customer can't pick an orientation, a size only counts if it has an orientation-less
  // entry, because getPlateVariant can't resolve an oriented one without state.orientation.
  function plateExists(style, finish, size, orientation) {
    var needsUnoriented = !!size && !orientation && !orientationRequired();
    return Object.keys(data.plateVariants || {}).some(function (key) {
      if (!isPlateBuyable(data.plateVariants[key])) return false;
      var parts = key.split('|');
      return (!style || parts[0] === style)
        && (!finish || parts[1] === finish)
        && (!size || parts[2] === size)
        && (!orientation || parts.length < 4 || parts[3] === orientation)
        && (!needsUnoriented || parts.length < 4);
    });
  }

  // Engraving fee = the selected plate's bespoke-engraved (BE) variant price minus its
  // bespoke (B) variant price. There is no separate fee product since the 2026-09-21
  // model: when the customer enters engraving text the bundle parent line becomes the
  // BE variant (buildSingleBundleItems). Returns null when the plate has no BE variant,
  // which disables the engraving step exactly as a missing fee product used to.
  function getEngravingFee() {
    var plateVariant = getPlateVariant();
    if (!plateVariant || plateVariant.engravedId == null || plateVariant.engravedPrice == null) return null;
    if (plateVariant.engravedAvailable === false) return null;
    return {
      variantId: plateVariant.engravedId,
      price: Math.max(0, plateVariant.engravedPrice - plateVariant.price)
    };
  }

  // The variant the bundle parent line is added as: BE when engraving text is present
  // (and the plate supports engraving), otherwise B.
  function sellablePlateVariantId(plateVariant) {
    var fee = hasEngravingText() ? getEngravingFee() : null;
    return fee ? fee.variantId : plateVariant.id;
  }

  function calculateTotalCents() {
    var total = 0;
    var plateVariant = getPlateVariant();
    if (plateVariant) total += plateVariant.price;
    for (var i = 1; i <= (state.gangCount || 0); i++) {
      var slot = state.slots[i];
      if (!slot) continue;
      if (slot.split) {
        halfKeysForSlot(slot).forEach(function (k) { if (slot[k]) total += slot[k].price; });
      } else {
        total += slot.price;
      }
    }
    var fee = getEngravingFee();
    if (hasEngravingText() && fee) {
      total += fee.price;
    }
    var qty = Math.max(1, parseInt(state.quantity, 10) || 1);
    return total * qty;
  }

  function updatePriceDisplay() {
    var formatted = formatPrice(calculateTotalCents());
    if (priceValue) priceValue.textContent = formatted;
    if (headerPrice) headerPrice.textContent = formatted;
    builder.querySelectorAll(
      '.builder-header-price--step2, .builder-header-price--step3, .builder-header-price--step4'
    ).forEach(function (el) {
      el.textContent = formatted;
    });
  }

  function buildPlateSummaryLine() {
    var parts = [
      capitalise(state.style),
      getSizeLabel(),
      getFinishLabel(state.finish) + ' Plate'
    ].filter(Boolean);
    return parts.join(' | ');
  }

  function engravingDisplayLabel(posKey) {
    return fillTokens(I18N.engravingSwitchLabel || 'SWITCH __POS__', { '__POS__': String(posKey).toUpperCase() });
  }

  function formatEngravingSummary(above, below) {
    var parts = [];
    if (above) parts.push(fillTokens(I18N.engravingAboveSummary || 'above: __TEXT__', { '__TEXT__': above }));
    if (below) parts.push(fillTokens(I18N.engravingBelowSummary || 'below: __TEXT__', { '__TEXT__': below }));
    if (!parts.length) return '';
    return fillTokens(I18N.engravingSummary || 'Engraving – __PARTS__', { '__PARTS__': parts.join(', ') });
  }

  function updateStockStatus() {
    if (!stockStatus) return;

    // When a stock-plate swap is live, the customer receives that stock plate,
    // so its stock drives the status (the matcher only swaps when it has
    // enough inventory, so a live match is always in stock). Falls back to the
    // bespoke plate variant when there is no swap. Both shapes expose
    // .inventoryQuantity, which is all this reads.
    var variant = findStockPlateMatch() || getPlateVariant();
    if (!variant) {
      stockStatus.textContent = '';
      stockStatus.hidden = true;
      return;
    }

    stockStatus.hidden = false;
    if (variant.inventoryQuantity > 0) {
      stockStatus.textContent = I18N.inStock || 'In stock';
      stockStatus.classList.remove('builder-stock-status--oos');
    } else {
      stockStatus.textContent = '';
      stockStatus.hidden = true;
    }
  }

  // Renders an OOS warning above the nav bar when the selected plate variant
  // has zero (or negative) inventory. Continue-selling is enabled on the
  // bespoke product, so Shopify keeps the variant purchasable — we just warn
  // the customer about the lead time instead of blocking the sale. Copy and
  // date source mirror snippets/stock-calculator.liquid.
  function updateStockNotice() {
    if (!stockNotice) return;

    // A live stock-plate swap is in stock by construction (matcher gate), so
    // the bespoke lead-time notice must not show — point at the matched plate's
    // inventory, falling back to the bespoke variant when there is no swap.
    var variant = findStockPlateMatch() || getPlateVariant();
    if (!variant || variant.inventoryQuantity > 0) {
      stockNotice.hidden = true;
      stockNotice.innerHTML = '';
      updateStockStatus();
      return;
    }

    var strings = data.stockStrings || {};
    // Per-plate stock date from the blank-plate product (page model); page-level fallback.
    var date = variant.stockDate || data.plateStockDate;
    var message;
    if (date && date !== '(n/a)' && strings.expectedTemplate) {
      message = strings.expectedTemplate.replace('__SWITCH_BUILDER_DATE__', date);
    } else {
      message = strings.outButBackSoon || '';
    }

    if (!message) {
      stockNotice.hidden = true;
      stockNotice.innerHTML = '';
      return;
    }

    stockNotice.innerHTML = message;
    stockNotice.hidden = false;
  }

  function formatPrice(cents) {
    // No hardcoded currency fallback: on a multi-market store '£{{amount}}' silently
    // renders EU/US/AE prices with a pound sign. If the theme failed to supply a format,
    // emit the bare amount rather than assert a wrong currency.
    var format = data.moneyFormat || '{{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }

  // ----------------------------------------------------------------
  // Cart
  // ----------------------------------------------------------------

  function handleAddToCart() {
    if (isAdding) return;
    var items = buildCartItems();
    if (!items.length) return;

    isAdding = true;
    nextBtn.disabled = true;
    nextBtn.textContent = I18N.adding || 'Adding…';

    // Post to the market/locale's own endpoint (/en-pl/cart/add.js), not the domain root: a buyer's
    // localization cookie can be scoped to the locale path, and a root-relative request then runs in
    // the root market, where the plate is "sold out" (staging 2026-10-05). Same reason the theme
    // prefixes CartJS's requests in layout/theme.liquid. Shopify.routes.root ends with '/'.
    var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
    .then(function (res) {
      if (res.ok) return res.json();
      // Shopify returns a JSON body on a cart 422 with a human-readable `description`
      // (e.g. "All 1 X are in your cart", a sold-out message). The old code threw a bare
      // `Cart error <status>`, so neither the customer nor the console learned the actual
      // reason — and a bespoke add bundles several hidden child lines (modules + engraving
      // fee), so an intermittent failure almost always meant one specific variant was out
      // of stock. Read the body and carry the detail through to the catch.
      return res.json().catch(function () { return null; }).then(function (body) {
        var detail = body && (body.description || body.message);
        var err = new Error('Cart error ' + res.status + (detail ? ': ' + detail : ''));
        err.cartStatus = res.status;
        err.cartDetail = detail || '';
        err.cartBody = body;
        throw err;
      });
    })
    .then(function () {
      // Cart POST succeeded. Flip to "Build another" only if the customer is
      // still on Review — they may have clicked a "Change" link mid-request, in
      // which case goToStep already cleared justAdded and we leave it cleared.
      if (state.step === state.totalSteps) justAdded = true;
      // Basket-drawer refresh is best-effort: the item is already in the cart,
      // so a UI hiccup here must NOT fall through to the add-failure handler.
      try {
        if (typeof updateBasketContent === 'function') updateBasketContent();
        if (typeof openBasketPanel === 'function') openBasketPanel();
      } catch (uiErr) {
        console.error('Switch builder: basket UI refresh failed', uiErr);
      }
    })
    .catch(function (err) {
      // Genuine add failure — nothing was added. Stay in normal mode so the
      // button reads "Add to basket".
      justAdded = false;
      // Log the full Shopify error body so the real cause is visible in the console.
      console.error('Switch builder: cart add failed', err, err && err.cartBody);
      // Prefer Shopify's own (already-localised) description over the generic fallback —
      // it tells the customer *why* (usually a sold-out component).
      alert((err && err.cartDetail) || I18N.cartError || 'Sorry, there was a problem adding your switch to the basket. Please try again.');
    })
    .finally(function () {
      isAdding = false;
      // Re-render so the button label/disabled state reflect justAdded.
      updateUI();
    });
  }

  // "Build another" — wipe the current config back to a blank Step 1 so the
  // customer can compose a fresh plate without reloading the page. The Step-1
  // option-card `.selected` class is the visual source of truth (it is not
  // re-derived from state by updateUI), so it must be cleared by hand; Step 2/3
  // markup is regenerated on entry and the preview/availability/fades are
  // recomputed from the now-empty state by goToStep → updateUI.
  function resetBuilder() {
    justAdded = false;

    state.style = null;
    state.finish = null;
    state.size = null;
    state.sizeLabel = null;
    state.orientation = null;
    state.gangCount = null;
    state.slots = {};
    state.quantity = 1;
    state.termsAccepted = false;
    resetEngraving();

    expandedSlot = null;
    slotDrafts = {};

    builder.querySelectorAll('.option-card.selected').forEach(function (card) {
      card.classList.remove('selected');
    });

    if (termsCheckbox) termsCheckbox.checked = false;
    syncQuantityUI();

    goToStep(1);
  }

  function newBundleId() {
    return 'bundle_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9);
  }

  var BESPOKE_CART_PROPERTY_PREFIX = 'Bespoke | ';

  function bespokePositionPropertyKey(slotIndex, halfSuffix) {
    return BESPOKE_CART_PROPERTY_PREFIX + 'Position ' + slotIndex + (halfSuffix || '');
  }

  function moduleCartPropertyValue(mod) {
    if (!mod) return '';
    var sku = (mod.sku || '').trim();
    return sku || mod.title || '';
  }

  // One configured switch = one bundle (plate parent + module children + optional
  // engraving fee). The bundler Cart Transform expects quantity 1 on every line
  // and a unique _bundle_id per bundle — do not set quantity > 1 on child lines.
  // ----------------------------------------------------------------
  // Stock-plate matcher (Phase 2)
  // ----------------------------------------------------------------
  // When a bespoke config's aperture pattern (and style/finish/orientation/
  // gang/size) matches an existing stock plate, ship that stock SKU instead
  // of cutting a duplicate bespoke plate. findStockPlateMatch() is pure (reads
  // state, mutates nothing) so it doubles as the unit under test; the oracle
  // is corston-command-centre scripts/simulate-stock-plate-match.py. EU-only,
  // v1. Full spec: briefings/bespoke-stock-plate-matching.md (Phase 2).

  // Aperture pattern is encoded over 3 gang positions, each with an /a + /b
  // sub-slot, flattened to [1a,1b,2a,2b,3a,3b]. These helpers operate on the
  // 3 gang-pair blocks so symmetry transforms stay correct for <3-gang plates
  // (review finding 7) — a naive whole-array reverse would corrupt them.
  function gangPairs(p) {
    return [[p[0], p[1]], [p[2], p[3]], [p[4], p[5]]];
  }
  function flattenGangs(gs) {
    var out = [];
    for (var i = 0; i < gs.length; i++) { out.push(gs[i][0], gs[i][1]); }
    return out;
  }
  // A gang with a sole occupant always normalises it to the /a slot.
  function renormGangs(gs) {
    return gs.map(function (ab) {
      return (ab[0] === '' && ab[1] !== '') ? [ab[1], ''] : [ab[0], ab[1]];
    });
  }
  function padGangs(occ) {
    while (occ.length < 3) occ.push(['', '']);
    return occ;
  }
  // Horizontal mirror: reverse gang order, keep /a/b within a gang.
  function mirrorPatternEu(p, gc) {
    return flattenGangs(padGangs(renormGangs(gangPairs(p).slice(0, gc).reverse())));
  }
  // 180° rotation: reverse gang order AND swap /a/b within each gang.
  function rotatePatternEu(p, gc) {
    var occ = gangPairs(p).slice(0, gc).map(function (ab) { return [ab[1], ab[0]]; }).reverse();
    return flattenGangs(padGangs(renormGangs(occ)));
  }
  // Set of pattern signatures a plate is allowed to match, given its symmetry
  // flags. Slots are joined on a separator that can never appear in an
  // aperture value (so signatures compare as plain strings); without it
  // ["toggle",""] and ["","toggle"] would collide to the same string.
  var SIG_SEP = '\u0001';
  // US aperture-pattern shape: [1a, 1b, 1c, 2, 3, 4]. Unlike EU (every gang position
  // is a uniform a/b pair), only position 1 can stack — up to 3 modules, for keystone
  // stacking — because that is the only shape Stock Matrix(US Plates).csv has columns
  // for (Aperture 1/1a, 1b, 1c vs one column each for positions 2–4). A config that
  // stacks outside position 1 has no representation, so buildConfigSignatureUs()
  // returns null (safe: always-bespoke, matching that no stock plate has that layout).
  // US stock data has no "rotatable" concept; rotatePatternUs is a null stub so
  // equivSet's rotatable branch fails safe.
  function mirrorPatternUs(sig, gc) {
    if (sig[1] || sig[2]) return null;
    var vals = [sig[0], sig[3], sig[4], sig[5]].slice(0, gc).reverse();
    return [vals[0] || '', '', '', vals[1] || '', vals[2] || '', vals[3] || ''];
  }
  function rotatePatternUs(sig, gc) {
    return null;
  }
  function mirrorPattern(p, gc) {
    return IS_US ? mirrorPatternUs(p, gc) : mirrorPatternEu(p, gc);
  }
  function rotatePattern(p, gc) {
    return IS_US ? rotatePatternUs(p, gc) : rotatePatternEu(p, gc);
  }
  function equivSet(plate) {
    var p = plate.pattern, gc = plate.gangCount;
    var keys = [p.join(SIG_SEP)];
    function add(arr) {
      if (!arr) return;
      var k = arr.join(SIG_SEP);
      if (keys.indexOf(k) < 0) keys.push(k);
    }
    if (plate.reversable) add(mirrorPattern(p, gc));
    if (plate.rotatable) add(rotatePattern(p, gc));
    if (plate.reversable && plate.rotatable) {
      var mirrored = mirrorPattern(p, gc);
      var rotated = rotatePattern(p, gc);
      if (rotated) add(mirrorPattern(rotated, gc));
      if (mirrored) add(rotatePattern(mirrored, gc));
    }
    return keys;
  }

  function moduleAperture(mod) {
    return (mod && mod.aperture) ? mod.aperture : '';
  }

  // Build the config's 6-slot aperture signature in stock-plate order. A
  // non-split gang puts its aperture in /a (/b empty); a split gang fills
  // [a, b]. Returns null if incomplete OR if any chosen module has no aperture
  // (finding 8 — blank "" is also the empty-slot encoding, so a blank module
  // would over-match; bail to bespoke instead).
  function buildConfigSignature() {
    return IS_US ? buildConfigSignatureUs() : buildConfigSignatureEu();
  }

  // US: [1a,1b,1c,2,3,4]. Position 1 fills its 1–3 sub-slots from a stacked slot's
  // parts (or just 1a when unsplit); positions 2–4 are single-occupancy — a split slot
  // there bails to null. Gang counts above 4 also bail: the signature shape (and the
  // stock data behind it) stops at 4, so 5G/6G plates are always cut bespoke.
  function buildConfigSignatureUs() {
    if (state.gangCount > 4) return null;
    var sig = ['', '', '', '', '', ''];
    for (var i = 1; i <= state.gangCount; i++) {
      var slot = state.slots[i];
      if (!slot) return null;

      if (i === 1) {
        if (slot.split) {
          var parts = halfKeysForSlot(slot).map(function (k) { return slot[k]; });
          if (!parts.some(Boolean)) return null;
          for (var p = 0; p < parts.length; p++) {
            if (!parts[p]) continue;
            var pAp = moduleAperture(parts[p]);
            if (!pAp) return null;
            sig[p] = pAp;
          }
        } else {
          var ap1 = moduleAperture(slot);
          if (!ap1) return null;
          sig[0] = ap1;
        }
        continue;
      }

      if (slot.split) return null;
      var apN = moduleAperture(slot);
      if (!apN) return null;
      sig[i + 1] = apN;
    }
    return sig;
  }

  // EU: [1a,1b,2a,2b,3a,3b] — 3 gang positions, each an a/b pair.
  function buildConfigSignatureEu() {
    if (state.gangCount > 3) return null;
    var sig = ['', '', '', '', '', ''];
    for (var i = 1; i <= state.gangCount; i++) {
      var slot = state.slots[i];
      if (!slot) return null;
      var base = 2 * (i - 1);
      if (slot.split) {
        if (!slot.a && !slot.b) return null;
        if (slot.a) { var aAp = moduleAperture(slot.a); if (!aAp) return null; sig[base] = aAp; }
        if (slot.b) { var bAp = moduleAperture(slot.b); if (!bAp) return null; sig[base + 1] = bAp; }
      } else {
        var ap = moduleAperture(slot);
        if (!ap) return null;
        sig[base] = ap;
      }
    }
    return sig;
  }

  // Returns the matched stock-plate object (from data.stockPlates) or null.
  function findStockPlateMatch() {
    var pool = data.stockPlates || [];
    if (!pool.length) return null;
    if (!state.style || !state.finish || !state.size || !state.gangCount) return null;
    // Engraved configurations are never swapped: the swap ships an off-the-shelf blank
    // plate, which can't carry the engraving. Under the BE-variant model the engraved
    // bespoke plate is a different variant of the same product, so the bundle parent is
    // simply the BE variant and the matcher steps aside (the retired flow added a fee line
    // next to the stock plate instead).
    if (hasEngravingText() && getEngravingFee()) return null;

    var plateVariant = getPlateVariant();
    if (!plateVariant) return null;

    var sig = buildConfigSignature();
    if (!sig) return null;
    var sigKey = sig.join(SIG_SEP);

    var orientation = state.orientation || 'horizontal';
    var qtyNeeded = Math.max(1, parseInt(state.quantity, 10) || 1);

    for (var i = 0; i < pool.length; i++) {
      var sp = pool[i];
      if (sp.style !== state.style) continue;
      if (sp.finish !== state.finish) continue;
      // A rotatable plate can be physically turned 90° to mount in either
      // orientation, so it matches regardless of the config's orientation
      // (confirmed with Michael, 2026-06-19). Non-rotatable plates — incl. the
      // dedicated vertical 4x/6x families, which carry rotatable:false — must
      // still match orientation exactly.
      if (!sp.rotatable && (sp.orientation || 'horizontal') !== orientation) continue;
      if (sp.gangCount !== state.gangCount) continue;
      if (sp.size !== state.size) continue;
      if (equivSet(sp).indexOf(sigKey) < 0) continue;
      // finding 5: only swap when price parity holds and stock covers the
      // order; otherwise fall back to the bespoke plate (the safe default,
      // and what makes OOS handling free — review finding 5 / Phase 3).
      if (sp.price !== plateVariant.price) continue;
      if ((sp.inventoryQuantity || 0) < qtyNeeded) continue;
      return sp;
    }
    return null;
  }

  function buildSingleBundleItems(bundleId) {
    var plateVariant = getPlateVariant();
    if (!plateVariant) return [];

    var stockMatch = findStockPlateMatch();

    // Real module lines only — cutout / blank positions buy nothing.
    var moduleLines = [];
    for (var j = 1; j <= state.gangCount; j++) {
      var modSlot = state.slots[j];
      if (!modSlot) continue;
      var modulesForSlot = modSlot.split
        ? halfKeysForSlot(modSlot).map(function (k) { return modSlot[k]; })
        : [modSlot];
      modulesForSlot.forEach(function (mod) {
        if (!mod || isSyntheticModule(mod) || !mod.id) return;
        moduleLines.push({
          id: mod.id,
          quantity: 1,
          properties: {
            '_bundle_id': bundleId,
            '_bundle_item': 'true'
          }
        });
      });
    }

    // All-cutout config that matches a stock plate (never engraved — the matcher
    // steps aside for engraving): the customer is buying an off-the-shelf front plate,
    // so add it as a plain, refundable stock line — no bundle, no bespoke properties.
    if (stockMatch && !moduleLines.length) {
      return [{ id: stockMatch.variantId, quantity: 1, properties: {} }];
    }

    var items = [];
    var plateProperties = {
      '_bundle_id': bundleId,
      '_bundle_parent': 'true',
      '_bundle_style': capitalise(state.style),
      '_bundle_finish': getFinishLabel(state.finish),
      '_bundle_size': getSizeLabel(),
      // The size label is translatable ("4 moduli"); the size key isn't. App-Hub resolves the
      // plate geometry from it first, since Italian Grove's 4-module shares 2 positions with Double.
      '_bundle_size_key': state.size || '',
      '_bundle_engraved': hasEngravingText() ? 'true' : 'false'
    };
    // Orientation (horizontal/vertical) is a customer choice for plates where
    // orientationRequired() is true, but it isn't otherwise captured in the
    // readable spec — the App-Hub order→image renderer needs it to know whether
    // to rotate the plate 90°. Emit it as an explicit prop when chosen.
    if (state.orientation) {
      plateProperties['_bundle_orientation'] = capitalise(state.orientation);
    }
    for (var i = 1; i <= state.gangCount; i++) {
      var slot = state.slots[i];
      if (!slot) continue;
      if (slot.split) {
        halfKeysForSlot(slot).forEach(function (k) {
          if (slot[k]) plateProperties[bespokePositionPropertyKey(i, k)] = moduleCartPropertyValue(slot[k]);
        });
      } else {
        plateProperties[bespokePositionPropertyKey(i)] = moduleCartPropertyValue(slot);
      }
    }
    plateProperties['_bespoke_spec'] = buildBespokeSpec();

    if (hasEngravingText()) {
      Object.keys(state.engraving.values).forEach(function (key) {
        plateProperties['Engraving | ' + key] = state.engraving.values[key];
      });
    }

    // Stock-plate swap: when the config matches a stock plate, the bundle
    // parent line becomes that stock SKU's variant (the customer receives the
    // stock plate, not a duplicate cut). Price is unchanged — the matcher only
    // swaps when prices are at parity (findStockPlateMatch gate), so the
    // bundle total is identical whichever variant is the parent. The
    // underscore-prefixed props are hidden from the cart UI and exist for
    // fulfilment/ops (_stock_match SKU) and audit (_bespoke_price). The app's
    // run.js reads _stock_match to title the merged line (Phase 4).
    if (stockMatch) {
      plateProperties['_stock_match'] = stockMatch.sku || '';
      plateProperties['_bespoke_price'] = String(plateVariant.price);
    }

    items.push({
      id: stockMatch ? stockMatch.variantId : sellablePlateVariantId(plateVariant),
      quantity: 1,
      properties: plateProperties
    });

    // A config with no real modules (every position a cutout or blank) is a lone parent
    // line: the bundler needs >= 2 lines to merge, so it stays the plate's B/BE variant
    // with its Position properties, and the basket lists those (product-properties-basket).
    items = items.concat(moduleLines);

    // No separate engraving fee line: an engraved configuration is sold as the plate's
    // BE variant (sellablePlateVariantId above); the fee is the BE − B price difference.

    return items;
  }

  function buildCartItems() {
    if (!getPlateVariant()) return [];

    var bundleCount = Math.max(1, parseInt(state.quantity, 10) || 1);
    var items = [];
    for (var q = 0; q < bundleCount; q++) {
      items = items.concat(buildSingleBundleItems(newBundleId()));
    }
    return items;
  }

  // ----------------------------------------------------------------
  // Helpers
  // ----------------------------------------------------------------

  function capitalise(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // Display name for a module category. The category KEY (metaobject
  // module_category) is locale-stable and drives logic (isInsertCategory,
  // SWITCH_TYPES, filtering) — never show it directly. The translatable label
  // already exists on the section's module_category blocks (theme content,
  // translated via Translate & Adapt), so map key → block label here.
  function categoryLabel(categoryKey) {
    var match = (data.moduleCategories || []).filter(function (c) { return c.value === categoryKey; })[0];
    if (match && match.label) return match.label;
    return capitalise(categoryKey || '');
  }

  function getFinishLabel(value) {
    var match = (data.finishes || []).filter(function (f) { return f.value === value; })[0];
    if (match) return match.label;
    var insert = (data.insertColours || DEFAULT_INSERT_COLOURS).filter(function (f) {
      return f.value === value;
    })[0];
    if (insert) return insert.label;
    return capitalise(value);
  }

  function getSizeLabel() {
    return state.sizeLabel || capitalise(state.size) || (state.gangCount ? state.gangCount + '-gang' : '');
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ----------------------------------------------------------------
  // Start
  // ----------------------------------------------------------------

  init();

})();
